// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-09T16:37:01.020Z
// Property: Tapestry Westland Village (ID: 5713142352969728)
// Collections: 27 amenities, 13 floorplans (live), 28 photos, 84 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5713142352969728",
  "property_external_id": "4892255",
  "property_zillow_url": "https://www.zillow.com/apartments/jacksonville-fl/tapestry-westland-village/Bhkh8g/",
  "property_apartments_url": "https://www.apartments.com/tapestry-at-westland-village-jacksonville-fl/qk3mprw",
  "property_google_business_url": "https://www.google.com/maps/place/Tapestry+Westland+Village/@30.2051355,-81.7503437,17z/data=!4m13!1m7!3m6!1s0x88e5c6ee7ba3767d:0x18f7311a371b398a!2s6505+Collins+Rd,+Jacksonville,+FL+32244!3b1!8m2!3d30.2051355!4d-81.7481497!3m4!1s0x88e5c70968646e63:0x798d3c7ca34d3f93!8m2!3d30.205101!4d-81.7480619",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443201073",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "tapestry-westland-village",
  "property_name": "Tapestry Westland Village",
  "property_website_url": "https://www.tapestrywestlandvillage.com/",
  "property_domain": "https://www.tapestrywestlandvillage.com/",
  "property_address": "6505 Collins Rd",
  "property_full_address": "6505 Collins Rd, Jacksonville, FL 32244",
  "property_address_1": "6505 Collins Rd",
  "property_address_2": null,
  "property_address_city": "Jacksonville",
  "property_address_state": "FL",
  "property_address_zip_full": "32244-5368",
  "property_address_zip": "32244",
  "property_address_country": "US",
  "property_address_county": "Duval County",
  "property_neighborhood_address": "Southwest",
  "property_address_latitude": "30.20724439999999",
  "property_address_longitude": "-81.7496456",
  "property_email": "tapestry@alapts.com",
  "property_phone": "(904) 420-8033",
  "property_call_tracking_phone": "904-822-3591",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern Westside Jacksonville living, with room to unwind.</strong> Explore polished studio to three-bedroom apartments with chef-inspired kitchens, granite countertops, stainless-steel appliances, and resort-style spaces designed for everyday ease—then schedule a tour of Tapestry Westland Village.</p>",
  "property_long_description": "<p><strong>Modern Westside Jacksonville living, with room to unwind.</strong> At Tapestry Westland Village, you can move between polished apartment interiors and resort-style shared spaces without leaving the Duclay neighborhood. Choose from studio, one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with chef-inspired kitchens, granite countertops, stainless-steel appliances, full-sized washers and dryers, walk-in closets, and private patios or balconies in select layouts.</p><p>Outside your door, spend the afternoon at the saltwater pool with sun shelf, meet up in the resident clubhouse, fit in a workout with the modern fitness center, yoga studio, spin room, and on-demand virtual trainer, or take advantage of Wi-Fi in the clubhouse and pool area. The pet park, outdoor pavilion, grilling stations, billiards, business center, and door-to-door trash pickup add everyday ease—see more on the <a href=\"/amenities\">amenities</a> page.</p><p>Set just off Collins Road in Duclay, you’re near I-295 and Blanding Boulevard for cross-town access, with Oakleaf Town Center, Argyle Village, Costco, Walmart, Renna’s Pizza, Sushi Wok, Orange Park Mall, Clark House Park, and Stinson Park all within easy reach.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f3-3440-7494-a4be-3c391acb9c8c.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
    "public_id": "019d02f3-3440-7494-a4be-3c391acb9c8c",
    "storage_key": "property/5713142352969728/019d02f3-3440-7494-a4be-3c391acb9c8c.webp",
    "width": 1191,
    "height": 844
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "266",
  "property_year_built": "2020",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.49624060150376",
  "property_admin_fee": "250",
  "property_application_fee": "85",
  "property_fees_deposit_info": "Application Fee $85\nAdministrative Fee $250\nNon-Refundable Pet Fee $400 / pet\nMonthly Pet Rent $30 / pet\nApplication Approval Fee Starting At $399\n",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8778161.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://tapestrywestlandvillage.loftliving.com/login",
  "property_apply_now_url": "https://8778161.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e7030-ed2e-7399-917f-b6268caafce5.webp",
  "property_primary_logo_media": {
    "alt_text": "Tapestry Westland Village logo",
    "public_id": "019e7030-ed2e-7399-917f-b6268caafce5",
    "storage_key": "property/5713142352969728/019e7030-ed2e-7399-917f-b6268caafce5.webp",
    "width": 1234,
    "height": 532
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f3-27e8-749b-b633-7ae9c938ac70.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02f3-27e8-749b-b633-7ae9c938ac70",
    "storage_key": "property/5713142352969728/019d02f3-27e8-749b-b633-7ae9c938ac70.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e7030-ed2b-7283-974e-f024466b8b04.webp",
  "property_icon_media": {
    "alt_text": "Property logo",
    "public_id": "019e7030-ed2b-7283-974e-f024466b8b04",
    "storage_key": "property/5713142352969728/019e7030-ed2b-7283-974e-f024466b8b04.webp",
    "width": 368,
    "height": 368
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e7030-ed2b-7283-974e-f024466b8b04.webp",
  "property_fav_icon_media": {
    "alt_text": "Property logo",
    "public_id": "019e7030-ed2b-7283-974e-f024466b8b04",
    "storage_key": "property/5713142352969728/019e7030-ed2b-7283-974e-f024466b8b04.webp",
    "width": 368,
    "height": 368
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e7030-ee49-742d-910c-0422a67ac584.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Tapestry Westland Village logo",
    "public_id": "019e7030-ee49-742d-910c-0422a67ac584",
    "storage_key": "property/5713142352969728/019e7030-ee49-742d-910c-0422a67ac584.webp",
    "width": 1234,
    "height": 532
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e7030-edf5-74d9-a423-f7553256ede8.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Tapestry Westland Village logo",
    "public_id": "019e7030-edf5-74d9-a423-f7553256ede8",
    "storage_key": "property/5713142352969728/019e7030-edf5-74d9-a423-f7553256ede8.webp",
    "width": 1229,
    "height": 530
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#6d6a2c",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#f3b357",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "725 - 1324",
  "property_sqft_min": "725",
  "property_sqft_max": "1324",
  "property_price_range": "1341.66 - 2201",
  "property_price_min": "1341.66",
  "property_price_max": "2201",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/TapestryWestlandVillage",
  "property_instagram_url": "https://www.instagram.com/tapestrywestlandvillage",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJY25kaAnH5YgRkz9No3w8jXk",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/westland-park-apartments-jacksonville",
  "property_tiktok_url": "https://www.tiktok.com/discover/tapestry-westland-village-apartments-jacksonville-fl",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Downtime gets an upgrade at Tapestry Westland Village.</strong> Lounge by the saltwater pool with sun shelf, settle into the Wi-Fi clubhouse with billiards and gaming tables, or reset in the fitness center, yoga studio, and spin room. Outdoor grilling stations, a pavilion, and an onsite Bark Park add even more room to unwind—while select homes bring the polish with granite countertops, glass subway tile, garden tubs, and private patios or balconies.</p>",
  "property_home_floorplans_blurb": "<p><strong>Studio to three-bedroom layouts, polished for every day.</strong> Explore floor plans with chef-inspired kitchens, oversized 42-inch cabinetry, granite countertops, stainless-steel appliances, full-sized washers and dryers, and select walk-in closets. Choose added touches like a private patio or balcony, lake views where available, double-sink vanities, or garden tubs—then compare current availability and find the space that fits.</p>",
  "property_home_gallery_blurb": "<p><strong>See the spaces take shape.</strong> Preview granite kitchen islands, white cabinetry, stainless-steel appliances, glass tile accents, and wood-style plank flooring, then step outside to patios, balconies, and green courtyards. The gallery also spotlights the saltwater pool with in-water loungers, shaded pavilion with TVs and gaming, polished clubhouse, and fitness spaces that define Tapestry Westland Village.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Westside ease with room to roam.</strong> Set near Collins Road, Blanding Boulevard, and I-295, Tapestry Westland Village keeps daily stops close—from Blanding Market to Wicked Batter Café and The Juicy Crab. For fresh air, Ringhaver Park brings trails, pickleball, and Ortega River boardwalk views just a short drive away, while JTA’s Orange Line adds connection toward Orange Park Mall, Riverside, and downtown Jacksonville.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents are sharing what stands out:</strong> a peaceful, clean community, modern appliances, and a team that makes apartment living feel easy. Reviews call out fast maintenance—including AC service within 30 minutes—and a leasing experience described as enjoyable and stress-free, with Stephany often praised for her welcoming, knowledgeable support. Read more to see what life at Tapestry Westland Village is like.</p>",
  "property_neighborhood_blurb": "<p><strong>Westside convenience with a laid-back Duclay feel.</strong> From Tapestry Westland Village, your map opens onto the everyday ease of Collins Road, Blanding Boulevard, and quick I-295 access—putting groceries, coffee, local dining, and retail errands within a simple drive. Browse Blanding Market, grab a bite at Wicked Batter Café or The Juicy Crab, or trade pavement for riverfront scenery at Ringhaver Park, where trails, pickleball, and the Ortega River boardwalk add a fresh-air reset close to home. JTA’s Orange Line along Blanding offers another way to connect toward Orange Park Mall, FSCJ Kent Campus, Riverside, and downtown. When you’re ready to see how the location fits your routine, <a href=\"/schedule-a-tour\">schedule a tour</a> and explore the neighborhood in person.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Built for easy days and elevated downtime.</strong> At Tapestry Westland Village, amenities go beyond the basics—start with a saltwater pool with sun shelf, an expansive porch made for lingering, and a clubhouse with Wi-Fi, billiards, gaming tables, and a WFH business center when you need a change of scenery.</p><p>Keep your routine close with a modern fitness center, yoga studio, spin room, and on-demand virtual trainer, then head outside to the pavilion and grilling stations or the onsite Bark Park. Inside select apartment homes, chef-inspired kitchens, granite countertops, glass subway tile backsplashes, full-sized washers and dryers, barnwood-style plank flooring, garden tubs, and private patios or balconies add polish to every day. Preview the spaces in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience them in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to apply?</strong> Start your online application for Tapestry Westland Village and move closer to modern Westside Jacksonville living with polished interiors, chef-inspired kitchens, granite countertops, stainless-steel appliances, and room to unwind. Resort-style shared spaces add everyday ease—right in the Duclay neighborhood.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Connect with the leasing team at Tapestry Westland Village for help exploring modern apartments, resort-style spaces, and our Collins Road location in Duclay. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Tapestry Westland Village?</strong> Start here for quick answers about our Duclay community, leasing details, apartment features, and everyday living. If you don’t see what you need, the leasing team is happy to help you find the right next step.</p>",
  "property_floorplans_blurb": "<p><strong>Find the shape that fits your day.</strong> At Tapestry Westland Village, floor plans range from efficient studio and one-bedroom layouts to roomier two- and three-bedroom apartments, so you can compare the space, pricing, and availability that matter most at a glance. Each home is designed to feel polished and practical, with chef-inspired kitchens, oversized 42-inch cabinetry, granite countertops, stainless-steel appliances, full-sized washers and dryers, and walk-in closets in select layouts.</p><p>Choose a plan with a private patio or balcony, explore options with lake views where available, or look for layouts with double-sink vanities and garden tubs for a more elevated finish. Browse current availability, preview interiors in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite Jacksonville apartment floor plan in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture the details before you tour.</strong> Browse bright kitchens with granite islands, white cabinetry, stainless-steel appliances, and glass tile that catches the light. Move through open living areas with wood-style plank flooring, calm bedrooms, organized closets, and patios or balconies that extend the view.</p><p>The gallery also brings the community into focus: a saltwater pool with in-water loungers, a shaded pavilion with TVs and gaming spaces, a polished clubhouse, and fitness areas made for movement. See how the interiors, outdoor gathering spots, and green courtyards come together at Tapestry Westland Village, then compare <a href=\"/floor-plans\">available layouts</a>, explore more <a href=\"/amenities\">amenity details</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Find your place in Duclay.</strong> Use the interactive map to explore available apartments at Tapestry Westland Village, then zoom out to see how Collins Road, I-295, Blanding Boulevard, shopping, dining, and nearby parks connect around you.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living with space to play.</strong> At Tapestry Westland Village, your daily routine has built-in room for paws, whiskers, and wagging tails. Start the morning with an easy outing at the onsite Bark Park, then head back to a comfortable apartment where private patios or balconies, walk-in closets, and full-sized washers and dryers are available in select homes to help keep pet life simple. Cats and dogs are welcome, with no weight limit, so you can focus on finding the right layout rather than compromising on your companion.</p><p>When errands call, pet supplies are close by along Collins Road, and the community’s online resident services and onsite maintenance help keep everyday details moving. Explore more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the grounds in person.</p>",
  "property_referafriend_blurb": "<p><strong>Love where you live? Share it.</strong> Invite a friend to discover modern Westside Jacksonville living with polished apartment interiors, private patios or balconies in select layouts, and resort-style spaces made for unwinding—all right here at Tapestry Westland Village.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Tapestry Westland Village.</strong><br>Keep everyday apartment living simple from your resident portal. Pay rent, submit maintenance requests, and manage your account online—then get back to enjoying polished interiors, resort-style shared spaces, and the everyday ease of home in Duclay.</p>",
  "property_reviews_blurb": "<p><strong>Hear what life at Tapestry Westland Village is like from the people who know it best.</strong> In these reviews, you’ll find praise for a “peaceful and clean” community, modern appliances, and service that helps apartment living feel easier.</p><p>Residents highlight responsive maintenance, including AC service that arrived within 30 minutes, and a leasing experience described as “enjoyable and stress-free.” The team—especially Stephany—is often recognized for being knowledgeable, professional, welcoming, and helpful throughout tours and move-ins. Read the reviews below to see the experiences residents are sharing.</p>",
  "property_created_at": "1752256587621",
  "property_scheduletour_blurb": "<p><strong>See Tapestry Westland Village in person.</strong> Tour polished interiors with chef-inspired kitchens, granite countertops, stainless-steel appliances, and walk-in closets, then get a feel for the saltwater pool, clubhouse, and fitness spaces just outside your door. Schedule your tour and picture life in modern Westside Jacksonville style.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will follow up soon with next steps. In the meantime, picture modern Westside Jacksonville living with polished interiors, chef-inspired kitchens, and resort-style spaces designed for easy days at Tapestry Westland Village.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> Explore Tapestry Westland Village from wherever your Jacksonville apartment search starts, with virtual tours that let you pause, turn, and compare the spaces that matter. Move through the community tour and Clubroom, where polished lounge areas, work-friendly nooks, billiards and gaming space, and poolside gathering areas show how the shared amenities come together.</p><p>Then take a closer look at three apartment walkthroughs: the open Captiva two-bedroom, the Amelia one-bedroom, and the Little Talbot studio. As you tour, notice the bright kitchens, granite counters, subway tile, stainless-steel appliances, wood-style plank flooring, smart storage, and natural light that are easier to understand in motion. When a layout feels right, compare <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Tapestry Westland Village",
  "property_seo_title_home": "Tapestry Westland Village |  Apartments in Jacksonville, FL",
  "property_seo_description_home": "Experience modern living at Tapestry Westland Village in Jacksonville, FL. Choose from diverse floor plans with stellar amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Jacksonville, FL Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Tapestry Westland Village in Jacksonville, FL. Choose from studio to three-bedroom layouts designed for comfort and style.",
  "property_seo_title_amenities": "Amenities | Jacksonville, FL Apartments for Rent",
  "property_seo_description_amenities": "Experience Tapestry Westland Village in Jacksonville, FL, where luxury meets comfort. Dive into our enticing amenities and stylish floor plans today!",
  "property_seo_title_gallery": "Gallery | Apartments in Jacksonville, FL",
  "property_seo_description_gallery": "Discover Tapestry Westland Village in Jacksonville—a vibrant retreat. Browse our gallery and envision your dream home with luxurious amenities!",
  "property_seo_title_virtualtours": "Virtual Tours | Tapestry Westland Village Apartments",
  "property_seo_description_virtualtours": "Discover your future home at Tapestry Westland Village, Jacksonville. Choose from stylish studios to three-bedroom apartments. Take a virtual tour!",
  "property_seo_title_interactivemap": "Interactive Map | Tapestry Westland Village Apartments",
  "property_seo_description_interactivemap": "Experience life at Tapestry Westland Village in Jacksonville, FL! Use our interactive map to find your perfect studio, one, two, or three-bedroom home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Jacksonville, FL",
  "property_seo_description_neighborhood": "Uncover Jacksonville's charm at Tapestry Westland Village. From studios to three-bedroom homes, discover local gems and community hotspots just steps away!",
  "property_seo_title_contact": "Contact Us | Tapestry Westland Village",
  "property_seo_description_contact": "Connect with Tapestry Westland Village in Jacksonville, FL! From studio to three-bedroom plans, our leasing team is ready to help. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Jacksonville, FL",
  "property_seo_description_faqs": "Find quick answers to your queries about Tapestry Westland Village in Jacksonville, FL. From amenities to floor plans, we've got you covered!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Jacksonville, FL",
  "property_seo_description_reviews": "Unveil the charm of Tapestry Westland Village in Jacksonville, FL! See what our residents love about their vibrant lifestyle and modern amenities today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Jacksonville, FL",
  "property_seo_description_applynow": "Unlock comfort and style at Tapestry Westland Village in Jacksonville, FL. Choose from diverse floor plans and enjoy unbeatable amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Tapestry Westland Village",
  "property_seo_description_residentaccess": "Log in to Tapestry Westland Village’s resident portal for seamless rent payments, easy maintenance requests, and convenient community updates in Jacksonville, FL.",
  "property_seo_title_referafriend": "Refer A Friend | Tapestry Westland Village",
  "property_seo_description_referafriend": "Refer a friend to Tapestry Westland Village in Jacksonville, FL! Share the joy of great living where community and comfort come together. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Tapestry Westland Village",
  "property_seo_description_scheduletour": "Step into luxury at Tapestry Westland Village in Jacksonville, FL. Schedule your tour today and experience vibrant living in our stunning community!",
  "property_seo_title_privacy": "Privacy Policy | Tapestry Westland Village",
  "property_seo_description_privacy": "Your privacy matters at Tapestry Westland Village. Learn how we protect your information while you enjoy the comfort of our Jacksonville apartments. Read more.",
  "property_seo_title_accessibility": "Website Accessibility | Tapestry Westland Village",
  "property_seo_description_accessibility": "Experience vibrant living at Tapestry Westland Village in Jacksonville, FL. We prioritize accessibility for all, ensuring everyone feels at home with us.",
  "property_seo_title_sitemap": "Sitemap | Tapestry Westland Village",
  "property_seo_description_sitemap": "Navigate your way to Tapestry Westland Village in Jacksonville, FL! Our sitemap guides you through exquisite living and vibrant community features.",
  "property_seo_title_thankyou": "Thank You | Tapestry Westland Village",
  "property_seo_description_thankyou": "Thank you for reaching out to Tapestry Westland Village! Expect a quick reply from our team as we help you find your perfect Jacksonville home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320325",
  "amenities": [
    {
      "id": "custom_7e2bdcac-1eb5-4dd5-ad21-b78fea4b640b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_46410b08-c047-40fe-9607-5143265e91ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000602",
      "title": "Billiards",
      "amount": "0.0000",
      "description": "Billiards & Gaming Tables",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_43abc419-8d97-4d83-acc2-542a8e0ee0b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000603",
      "title": "Blinds",
      "amount": "0.0000",
      "description": "2-Inch Blinds",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fc38653c-5d31-4f1c-a9d3-fea77c3c7d59",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000607",
      "title": "Business Center",
      "amount": "0.0000",
      "description": "WFH Business Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cce09e41-118a-4a14-8d97-4f1bab488180",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000613",
      "title": "Chef`s Kitchen",
      "amount": "0.0000",
      "description": "Chef-Inspired Kitchen w/ Oversized Cabinets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b14b5cc8-334a-4f31-a68e-a4d261b98d1a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f531d61b-1678-4441-b631-c314832a33f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000629",
      "title": "Double Vanity",
      "amount": "0.0000",
      "description": "Vanities w/ Double Sinks*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bf25aa7b-0291-414e-ab70-eeb6d8681132",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern Fitness Center & Yoga Studio",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b1a1a169-8c45-42e3-8b14-c385342366b8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000641",
      "title": "Garden Tub",
      "amount": "0.0000",
      "description": "Luxurious Garden Tub",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_29120868-9015-413e-a592-22128166283c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Weathered Barnwood-Style Plank Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e0011174-4618-479d-b239-2c240086efad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0364f3ec-7662-4457-b4d7-3e0e506a5a7f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000654",
      "title": "Lake Views",
      "amount": "0.0000",
      "description": "Lake Views*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8bb2c0e6-8a5a-4513-a1bd-d95dee40e8d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000659",
      "title": "On Demand Fitness",
      "amount": "0.0000",
      "description": "On-Demand Virtual Trainer",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2e938b63-5559-4522-9e9c-124c8e2b58a0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_29d8306e-9333-4410-b763-84bbbe414f4e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios & Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e96f6e1f-479a-4b2e-a36a-ef7d7c8000dc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_172fa18c-a0b0-460a-a7ac-d9832fcd510b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000676",
      "title": "Sink",
      "amount": "0.0000",
      "description": "Granite Countertops w/ Undermount Sink",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_02724588-2be4-4e90-8161-181dc8d4d834",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000684",
      "title": "Spin Room",
      "amount": "0.0000",
      "description": "Spin Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c18bf3c8-1f1a-4d53-bc06-3d5c3d1a8f28",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Glass Subway Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3ac7e76f-af05-4956-9756-fbe44690ff73",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "Full-Sized Washer & Dryer",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c995fe6b-1a39-4929-b2f4-c4b744ca8292",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Walk-In Closets & Closet Organizers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5fdf7029-91a8-4347-b726-191d8f55295b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000001279",
      "title": "BBQ",
      "amount": "0.0000",
      "description": "Outdoor Pavilion & BBQ Grilling Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c9f867c8-50d1-4ee2-aa38-6db0c4b85a0b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000001409",
      "title": "WiFi at Pool & Clubhouse",
      "amount": "0.0000",
      "description": "WiFi Throughout Clubhouse & Pool Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_42a443bc-e18e-4e66-a737-aee8305b9f3d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000002405",
      "title": "Resort Style Pool",
      "amount": "0.0000",
      "description": "Resort Style Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e57bc701-8d64-43f3-bdc7-28edc101418c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000002467",
      "title": "Outdoor TV lounge",
      "amount": "0.0000",
      "description": "Expansive Porch Overlooking Resort-Style Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1a6f7d40-c6e6-4da4-b501-347f37e16147",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000002520",
      "title": "Resident Clubhouse",
      "amount": "0.0000",
      "description": "Luxurious Resident Clubhouse",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d5f39c5f-85f1-40d2-8740-dc9260552749",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "external_id": "P000002540",
      "title": "Custom Saltwater Pool",
      "amount": "0.0000",
      "description": "Saltwater Pool w/ Sun Shelf",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_e8f5ae96-04a4-465c-978e-f18ace5448e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-6917-767c-905b-0d7a1d95e914.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and patio tables.",
        "public_id": "019e89b4-6917-767c-905b-0d7a1d95e914",
        "storage_key": "property/5713142352969728/019e89b4-6917-767c-905b-0d7a1d95e914.webp",
        "width": 2690,
        "height": 1794
      },
      "title": "Community",
      "description": "Relax by the resort-style pool, perfect for sunny days and evening unwinding. Enjoy ample seating and tables for convenience.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and patio tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cb30085f-5cd6-4d19-b039-d0d8f05d031f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-66e9-7799-b0b8-50e74801498b.webp",
      "image_media": {
        "alt_text": "Covered outdoor patio area with seating, tables, and an outdoor kitchen.",
        "public_id": "019e89b4-66e9-7799-b0b8-50e74801498b",
        "storage_key": "property/5713142352969728/019e89b4-66e9-7799-b0b8-50e74801498b.webp",
        "width": 2691,
        "height": 1794
      },
      "title": "Community",
      "description": "Relax and entertain in our spacious outdoor lounge area, complete with comfortable seating, dining tables, and a fully equipped outdoor kitchen.",
      "link": "",
      "alt_text": "Covered outdoor patio area with seating, tables, and an outdoor kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5a5f7cfb-e374-4b23-bbb9-896d6521705f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-68f6-7171-8b7f-59d547a416ad.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, white comforter, and a walk-in closet.",
        "public_id": "019e89b4-68f6-7171-8b7f-59d547a416ad",
        "storage_key": "property/5713142352969728/019e89b4-68f6-7171-8b7f-59d547a416ad.webp",
        "width": 2687,
        "height": 1790
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed with plush bedding and direct access to a convenient walk-in closet.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, white comforter, and a walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2e86d833-0f6c-4349-bf0f-06e034300628",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-655f-740b-b571-91e6ab097ee4.webp",
      "image_media": {
        "alt_text": "Patio table and chairs with outdoor view.",
        "public_id": "019e89b4-655f-740b-b571-91e6ab097ee4",
        "storage_key": "property/5713142352969728/019e89b4-655f-740b-b571-91e6ab097ee4.webp",
        "width": 2686,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening drinks on your private patio or balcony.",
      "link": "",
      "alt_text": "Patio table and chairs with outdoor view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_30822456-ff17-4ff5-94b3-277ff2bca33e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-5d77-7528-bc95-bd9d28382f2f.webp",
      "image_media": {
        "alt_text": "Hammock lounge area with apartment buildings in the background.",
        "public_id": "019e89b4-5d77-7528-bc95-bd9d28382f2f",
        "storage_key": "property/5713142352969728/019e89b4-5d77-7528-bc95-bd9d28382f2f.webp",
        "width": 2186,
        "height": 1456
      },
      "title": "Community",
      "description": "Relax in our outdoor hammock lounge, perfect for unwinding after a long day. Enjoy the serene ambiance of our beautiful community.",
      "link": "",
      "alt_text": "Hammock lounge area with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_550993e9-591d-4bc6-a0f9-1d1236aa7aae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-5544-7675-abe9-1f4f938d8b12.webp",
      "image_media": {
        "alt_text": "Modern kitchen area with coffee station and island seating, overlooking apartment buildings.",
        "public_id": "019e89b4-5544-7675-abe9-1f4f938d8b12",
        "storage_key": "property/5713142352969728/019e89b4-5544-7675-abe9-1f4f938d8b12.webp",
        "width": 2685,
        "height": 1791
      },
      "title": "Community",
      "description": "Enjoy a complimentary coffee in our sleek, modern resident lounge. Perfect for casual meetings or a quiet moment.",
      "link": "",
      "alt_text": "Modern kitchen area with coffee station and island seating, overlooking apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dcb8e723-15c6-4c9e-9f14-d767fb825ce3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-4f3d-71dd-a7cc-ff4baec5b005.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with in-water loungers and lounge chairs under palm trees.",
        "public_id": "019e89b4-4f3d-71dd-a7cc-ff4baec5b005",
        "storage_key": "property/5713142352969728/019e89b4-4f3d-71dd-a7cc-ff4baec5b005.webp",
        "width": 2689,
        "height": 1794
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning resort-style pool, complete with in-water loungers and ample seating for ultimate relaxation. Surrounded by lush palm trees, it's the perfect oasis.",
      "link": "",
      "alt_text": "Resort-style swimming pool with in-water loungers and lounge chairs under palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c5a02b35-b388-4e89-8059-0d48557d9cb8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-54bc-711c-ba41-8dfbbdeb94ab.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, toilet, and bathtub.",
        "public_id": "019e89b4-54bc-711c-ba41-8dfbbdeb94ab",
        "storage_key": "property/5713142352969728/019e89b4-54bc-711c-ba41-8dfbbdeb94ab.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "A stylish bathroom featuring a double vanity with granite countertops, a deep soaking tub, and contemporary finishes.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_313fcdd0-668e-4ab9-86f8-de1179fb2862",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-4aa8-7461-a55f-ec54bc9039cf.webp",
      "image_media": {
        "alt_text": "Outdoor covered patio with pool table and seating area, overlooking apartments and pool.",
        "public_id": "019e89b4-4aa8-7461-a55f-ec54bc9039cf",
        "storage_key": "property/5713142352969728/019e89b4-4aa8-7461-a55f-ec54bc9039cf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy recreation and relaxation at our community's covered outdoor lounge, complete with a pool table and comfortable seating, overlooking the sparkling pool and modern apartment buildings.",
      "link": "",
      "alt_text": "Outdoor covered patio with pool table and seating area, overlooking apartments and pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bfef3666-7a39-428d-afad-4350290c3911",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-515d-72e9-a92f-0b3134e03358.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, recumbent bikes, rowing machines, and weight machines.",
        "public_id": "019e89b4-515d-72e9-a92f-0b3134e03358",
        "storage_key": "property/5713142352969728/019e89b4-515d-72e9-a92f-0b3134e03358.webp",
        "width": 2688,
        "height": 1790
      },
      "title": "Community",
      "description": "State-of-the-art fitness center equipped with a variety of cardio and strength training equipment for residents.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, recumbent bikes, rowing machines, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8b95da76-c88e-49d6-9f8c-54dc515f87c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-4e0f-758d-8981-ed324c6ac35d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019e89b4-4e0f-758d-8981-ed324c6ac35d",
        "storage_key": "property/5713142352969728/019e89b4-4e0f-758d-8981-ed324c6ac35d.webp",
        "width": 2687,
        "height": 1791
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek stainless steel appliances, ample storage with white cabinetry, and elegant granite countertops.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f5fd57ff-bab6-4cd9-a36b-418a660fa4f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-4e2e-7038-bd96-744625ca85b3.webp",
      "image_media": {
        "alt_text": "Interior view of a modern multifamily property's common area, featuring a lounge with contemporary furniture and a small kitchen area.",
        "public_id": "019e89b4-4e2e-7038-bd96-744625ca85b3",
        "storage_key": "property/5713142352969728/019e89b4-4e2e-7038-bd96-744625ca85b3.webp",
        "width": 2687,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully designed common areas. Enjoy the modern lounge, fully equipped kitchen, and ample workspace.",
      "link": "",
      "alt_text": "Interior view of a modern multifamily property's common area, featuring a lounge with contemporary furniture and a small kitchen area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b0e89830-d2cf-4590-a334-fb0a084a4957",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-4c98-77ea-8cf5-279b71d75692.webp",
      "image_media": {
        "alt_text": "Bedroom with tufted headboard, white and grey bedding, and two framed art pieces above the bed.",
        "public_id": "019e89b4-4c98-77ea-8cf5-279b71d75692",
        "storage_key": "property/5713142352969728/019e89b4-4c98-77ea-8cf5-279b71d75692.webp",
        "width": 2683,
        "height": 1788
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush tufted headboard and elegant grey and white bedding.",
      "link": "",
      "alt_text": "Bedroom with tufted headboard, white and grey bedding, and two framed art pieces above the bed.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5535d996-fa43-4b61-934c-33ad0df67aed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-4a88-762a-9850-2d3f6aa6d05c.webp",
      "image_media": {
        "alt_text": "Apartment complex with buildings, courtyards, and palm trees.",
        "public_id": "019e89b4-4a88-762a-9850-2d3f6aa6d05c",
        "storage_key": "property/5713142352969728/019e89b4-4a88-762a-9850-2d3f6aa6d05c.webp",
        "width": 2186,
        "height": 1456
      },
      "title": "Community",
      "description": "Modern apartment buildings with lush courtyards, walking paths, and hammocks, offering a serene living environment.",
      "link": "",
      "alt_text": "Apartment complex with buildings, courtyards, and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_299486fd-df33-4aa2-8909-98856d9403e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-42b2-7538-8246-cd93b95644ca.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in an apartment with a white sofa, coffee table, and island seating.",
        "public_id": "019e89b4-42b2-7538-8246-cd93b95644ca",
        "storage_key": "property/5713142352969728/019e89b4-42b2-7538-8246-cd93b95644ca.webp",
        "width": 2686,
        "height": 1790
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area, perfect for entertaining. Features a comfortable white sofa, a modern coffee table, and a breakfast bar with seating.",
      "link": "",
      "alt_text": "Living room and kitchen area in an apartment with a white sofa, coffee table, and island seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ebcbb426-3938-42e4-8bf7-af486b776500",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-389e-70f8-a60d-95c584d9db79.webp",
      "image_media": {
        "alt_text": "Comfortable lounge area with sofas, chairs, coffee table, and dining set.",
        "public_id": "019e89b4-389e-70f8-a60d-95c584d9db79",
        "storage_key": "property/5713142352969728/019e89b4-389e-70f8-a60d-95c584d9db79.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring comfortable seating, a coffee table, and a dining area perfect for socializing or working remotely.",
      "link": "",
      "alt_text": "Comfortable lounge area with sofas, chairs, coffee table, and dining set.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_481ba17d-8736-48b7-9629-d271d5880569",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-352b-76cd-9e63-234779cf16b5.webp",
      "image_media": {
        "alt_text": "Tapestry Westland Village property signage with building exterior and \"Now Leasing\" banner in the background.",
        "public_id": "019e89b4-352b-76cd-9e63-234779cf16b5",
        "storage_key": "property/5713142352969728/019e89b4-352b-76cd-9e63-234779cf16b5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Tapestry Westland Village, featuring modern apartment living. See our community amenities and available floor plans.",
      "link": "",
      "alt_text": "Tapestry Westland Village property signage with building exterior and \"Now Leasing\" banner in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1eae04fb-7229-4687-929a-429a222c78a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-2fef-7530-9be5-09fc7578a1a3.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e89b4-2fef-7530-9be5-09fc7578a1a3",
        "storage_key": "property/5713142352969728/019e89b4-2fef-7530-9be5-09fc7578a1a3.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and beautiful apartment buildings.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5830ad1a-65d1-4071-a395-b1bef63298fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-2f7e-74be-92f9-51e5fb6c3071.webp",
      "image_media": {
        "alt_text": "Covered outdoor lounge area with seating, tables, and a bar.",
        "public_id": "019e89b4-2f7e-74be-92f9-51e5fb6c3071",
        "storage_key": "property/5713142352969728/019e89b4-2f7e-74be-92f9-51e5fb6c3071.webp",
        "width": 2690,
        "height": 1794
      },
      "title": "Community",
      "description": "Enjoy the outdoors in our beautifully appointed covered lounge area, perfect for socializing or relaxing. Features comfortable seating, dining tables, and a full-service bar.",
      "link": "",
      "alt_text": "Covered outdoor lounge area with seating, tables, and a bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6d2a573e-f264-47f9-af37-a3f2b563321b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-2fa5-77f8-8444-488938b973a1.webp",
      "image_media": {
        "alt_text": "Modern living room with white sofa, coffee table, and entryway to bedroom.",
        "public_id": "019e89b4-2fa5-77f8-8444-488938b973a1",
        "storage_key": "property/5713142352969728/019e89b4-2fa5-77f8-8444-488938b973a1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed living space. Enjoy a bright and airy atmosphere with stylish furnishings, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room with white sofa, coffee table, and entryway to bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1f09ff3e-6195-4d84-aa35-6424648a673a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-2f2f-73ab-b44e-39882889c074.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019e89b4-2f2f-73ab-b44e-39882889c074",
        "storage_key": "property/5713142352969728/019e89b4-2f2f-73ab-b44e-39882889c074.webp",
        "width": 2690,
        "height": 1794
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by comfortable lounge chairs and lush palm trees. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f52db1ef-7abb-497a-963f-3fbb9c692075",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-2f2f-73ab-b44e-3dc4882dea5a.webp",
      "image_media": {
        "alt_text": "Kitchen island with seating and a modern kitchen with stainless steel appliances.",
        "public_id": "019e89b4-2f2f-73ab-b44e-3dc4882dea5a",
        "storage_key": "property/5713142352969728/019e89b4-2f2f-73ab-b44e-3dc4882dea5a.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring a spacious island with bar stools, granite countertops, and stainless steel appliances, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Kitchen island with seating and a modern kitchen with stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bb9b370c-a51e-468c-a663-5313b199c32c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-2f2d-74f8-ac1d-a495ea8c88ca.webp",
      "image_media": {
        "alt_text": "Luxurious bedroom with a king-size bed, warm orange accent wall, and elegant furnishings.",
        "public_id": "019e89b4-2f2d-74f8-ac1d-a495ea8c88ca",
        "storage_key": "property/5713142352969728/019e89b4-2f2d-74f8-ac1d-a495ea8c88ca.webp",
        "width": 2687,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush king-size bed, a chic accent wall, and ample storage, creating a serene retreat.",
      "link": "",
      "alt_text": "Luxurious bedroom with a king-size bed, warm orange accent wall, and elegant furnishings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d7cfbc14-e5c5-444b-a6e9-88999a77dd03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-2d2f-7408-86e4-10004ee7a36e.webp",
      "image_media": {
        "alt_text": "Spinning bikes and exercise equipment in a bright fitness center.",
        "public_id": "019e89b4-2d2f-7408-86e4-10004ee7a36e",
        "storage_key": "property/5713142352969728/019e89b4-2d2f-7408-86e4-10004ee7a36e.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Stay active and energized in our fully-equipped fitness center, featuring top-of-the-line spinning bikes and a variety of exercise equipment for your workout needs.",
      "link": "",
      "alt_text": "Spinning bikes and exercise equipment in a bright fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_021c11dd-cadd-4071-a799-b8e86cfe300e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-2f0b-770c-86d5-3568416de4f7.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with granite countertop, pendant lights, and bar stools.",
        "public_id": "019e89b4-2f0b-770c-86d5-3568416de4f7",
        "storage_key": "property/5713142352969728/019e89b4-2f0b-770c-86d5-3568416de4f7.webp",
        "width": 2686,
        "height": 1790
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring a granite-topped island with seating, stainless steel appliances, and ample cabinet space. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen island with granite countertop, pendant lights, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2dd4ef0b-99bc-47ba-aba7-34745578dd51",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-1aac-707c-9c10-c4df76e29e56.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, granite countertops, and walk-in shower.",
        "public_id": "019e89b4-1aac-707c-9c10-c4df76e29e56",
        "storage_key": "property/5713142352969728/019e89b4-1aac-707c-9c10-c4df76e29e56.webp",
        "width": 2686,
        "height": 1789
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, modern fixtures, and a walk-in shower. An artistic seashell print adds a decorative touch.",
      "link": "",
      "alt_text": "Bathroom with double vanity, granite countertops, and walk-in shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d79ce9e1-7616-4171-8c00-4a3c86cb466e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-1766-708c-832e-4639621a12a0.webp",
      "image_media": {
        "alt_text": "Washing machine and dryer in a laundry room with a dog painting and a basket of cleaning supplies.",
        "public_id": "019e89b4-1766-708c-832e-4639621a12a0",
        "storage_key": "property/5713142352969728/019e89b4-1766-708c-832e-4639621a12a0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for easy laundry days. Pet-friendly amenities like a dog bowl are also available.",
      "link": "",
      "alt_text": "Washing machine and dryer in a laundry room with a dog painting and a basket of cleaning supplies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_26cad2cb-76fd-4388-8759-725491a365e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019e89b4-17ce-7049-8836-c21744070a63.webp",
      "image_media": {
        "alt_text": "Tapestry property's leasing office reception desk.",
        "public_id": "019e89b4-17ce-7049-8836-c21744070a63",
        "storage_key": "property/5713142352969728/019e89b4-17ce-7049-8836-c21744070a63.webp",
        "width": 2686,
        "height": 1790
      },
      "title": "Community",
      "description": "Welcome to the leasing office at Tapestry, where our friendly staff is ready to assist you with all your apartment needs. Enjoy our modern and comfortable waiting area.",
      "link": "",
      "alt_text": "Tapestry property's leasing office reception desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_cd0edb1fea98b552b1528426",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Rosati's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "7051 Collins Rd #402, Jacksonville, FL 32244, USA",
      "poi_short_description": "Italian chain eatery featuring Chicago-style deep-dish pizza, plus pasta & sandwiches.",
      "poi_long_description": "Italian chain eatery featuring Chicago-style deep-dish pizza, plus pasta & sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-73a4-77c4-9a0e-8afc61d1dbaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-73a4-77c4-9a0e-8afc61d1dbaa",
        "storage_key": "property/5713142352969728/019f14fb-73a4-77c4-9a0e-8afc61d1dbaa.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://myrosatis.com/jacksonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=16094322153821320148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosatis-pizza",
      "poi_latitude": "30.2046918",
      "poi_longitude": "-81.7592956",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 904-801-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-05d2-733d-9a5b-568c18d7ebe1",
        "storage_key": "property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiXaWn0fH5YgR1DM4P7qEWt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_294ce3ec7cebcda576b10930",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "7051 Collins Rd, Jacksonville, FL 32244, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-6e2a-71c1-a7cb-354d3269d269.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-6e2a-71c1-a7cb-354d3269d269",
        "storage_key": "property/5713142352969728/019f14fb-6e2a-71c1-a7cb-354d3269d269.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/1022089/collins-i-295-7051-collins-rd-jacksonville-fl-32244-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=14127347166601544476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "30.2047434",
      "poi_longitude": "-81.7591843",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 904-573-8252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fc-013c-729f-a169-61a1de7fa518.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-013c-729f-a169-61a1de7fa518",
        "storage_key": "property/5713142352969728/019f14fc-013c-729f-a169-61a1de7fa518.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ_S2xxnfH5YgRHAPo62VrDsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_b8dad1cb634842d72e964eab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Salsas Mex Collins Rd",
      "poi_type": "Restaurants",
      "poi_address": "7083 Collins Rd, Jacksonville, FL 32244, USA",
      "poi_short_description": "Relaxed restaurant offering Mexican fare such as fajitas and quesadillas, plus margaritas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-6476-7571-8225-500b337418e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-6476-7571-8225-500b337418e5",
        "storage_key": "property/5713142352969728/019f14fb-6476-7571-8225-500b337418e5.webp",
        "width": 289,
        "height": 312
      },
      "poi_business_url": "https://salsasmexrestaurants.com/locations/salsas-mex-collins-rd/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17548693768730329805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salsas-mex-collins-rd",
      "poi_latitude": "30.2055741",
      "poi_longitude": "-81.7612678",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 904-513-4014",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-05d2-733d-9a5b-568c18d7ebe1",
        "storage_key": "property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2aV4FPH5YgRzUJIdQF8ifM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_0785cd01f26b1d084e19da3d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Cold Stone Creamery",
      "poi_type": "Restaurants",
      "poi_address": "7083 Collins Rd #105, Jacksonville, FL 32244, USA",
      "poi_short_description": "Ice cream chain offering design-your-own creations hand-mixed on a granite slab, plus shakes & more.",
      "poi_long_description": "Ice cream chain offering design-your-own creations hand-mixed on a granite slab, plus shakes & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-7329-71fd-8062-017125cd2434.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-7329-71fd-8062-017125cd2434",
        "storage_key": "property/5713142352969728/019f14fb-7329-71fd-8062-017125cd2434.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.coldstonecreamery.com/stores/23893?utm_source=gmb&utm_medium=gmb&utm_campaign=gmb&utm_id=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13028223085534456104&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cold-stone-creamery",
      "poi_latitude": "30.2055744",
      "poi_longitude": "-81.76121599999999",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 904-660-2983",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-05d2-733d-9a5b-568c18d7ebe1",
        "storage_key": "property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1xi69nHH5YgRKCnTq96LzbQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "ec_b7109a1194c9ac5c33a8ea29",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "China Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "7091 Collins Rd #201, Jacksonville, FL 32244, USA",
      "poi_short_description": "Family-owned, casual eatery offering Chinese standards such as fried rice and lo mein as well as some Americanized options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-6856-7125-9f6f-3491dcda0828.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-6856-7125-9f6f-3491dcda0828",
        "storage_key": "property/5713142352969728/019f14fb-6856-7125-9f6f-3491dcda0828.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chinakitchenjacksonvillefl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10248725480144726343&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "china-kitchen",
      "poi_latitude": "30.2054242",
      "poi_longitude": "-81.76102569999999",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 904-723-1117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-05d2-733d-9a5b-568c18d7ebe1",
        "storage_key": "property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQxpQesHG5YgRR2mFLIbJOo4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_c4e5f2014b8a8126bdde8af3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Jersey Mike's Subs",
      "poi_type": "Restaurants",
      "poi_address": "7091 Collins Rd #205, Jacksonville, FL 32244, USA",
      "poi_short_description": "New Jersey–based counter-serve sandwich chain serving jumbo subs filled with cold cuts & toppings.",
      "poi_long_description": "New Jersey–based counter-serve sandwich chain serving jumbo subs filled with cold cuts & toppings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-f105-76db-902b-aabf0ee9f1be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-f105-76db-902b-aabf0ee9f1be",
        "storage_key": "property/5713142352969728/019f14fb-f105-76db-902b-aabf0ee9f1be.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jerseymikes.com/13099/jacksonville-fl?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=921774045620395432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jersey-mikes-subs",
      "poi_latitude": "30.2053611",
      "poi_longitude": "-81.7606036",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 904-512-7675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-05d2-733d-9a5b-568c18d7ebe1",
        "storage_key": "property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX0bscu7O5YgRqN1gWJzMygw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "ec_cb8f0420c37dc73ac5c14815",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Filipino Kitchen OP",
      "poi_type": "Restaurants",
      "poi_address": "2141 Loch Rane Blvd #132, Orange Park, FL 32073, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-78c0-71c9-841b-87e331e967ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-78c0-71c9-841b-87e331e967ed",
        "storage_key": "property/5713142352969728/019f14fb-78c0-71c9-841b-87e331e967ed.webp",
        "width": 1003,
        "height": 1280
      },
      "poi_business_url": "http://filipinokitchenopfl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14433023655626129275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "filipino-kitchen-op",
      "poi_latitude": "30.1632049",
      "poi_longitude": "-81.751082",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-592-1052",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-05d2-733d-9a5b-568c18d7ebe1",
        "storage_key": "property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ19z6IJHF5YgRe79nnItmTMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_7bc0dacb9291c3a9f0a69e76",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Culver’s",
      "poi_type": "Restaurants",
      "poi_address": "7923 Parramore Rd, Jacksonville, FL 32244, USA",
      "poi_short_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_long_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-77f8-7258-ae9b-31495a524355.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-77f8-7258-ae9b-31495a524355",
        "storage_key": "property/5713142352969728/019f14fb-77f8-7258-ae9b-31495a524355.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "http://www.culvers.com/restaurants/jacksonville-fl-parramore-rd/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=15056701564256313749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "culvers",
      "poi_latitude": "30.203834",
      "poi_longitude": "-81.7574996",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 904-374-5736",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-05d2-733d-9a5b-568c18d7ebe1",
        "storage_key": "property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnR3PUF7H5YgRleGQgkwm9NA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_6e6883fd92a479422854aae0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "The Juicy Crab - Westside",
      "poi_type": "Restaurants",
      "poi_address": "8106 Blanding Blvd, Jacksonville, FL 32244, USA",
      "poi_short_description": "Raw oysters, fried catfish & steamed crabs offered in a relaxed atmosphere with flat-screen TVs.",
      "poi_long_description": "Raw oysters, fried catfish & steamed crabs offered in a relaxed atmosphere with flat-screen TVs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-739c-76b1-988d-622ebba1c19f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-739c-76b1-988d-622ebba1c19f",
        "storage_key": "property/5713142352969728/019f14fb-739c-76b1-988d-622ebba1c19f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thejuicycrabjax.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2926833360674406085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-juicy-crab---westside",
      "poi_latitude": "30.2027802",
      "poi_longitude": "-81.7400725",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 904-379-5517",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-05d2-733d-9a5b-568c18d7ebe1",
        "storage_key": "property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTZC8C_TG5YgRxb7CO28znig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_d123d375590a1c181b9f3876",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "MISSION BBQ",
      "poi_type": "Restaurants",
      "poi_address": "8440 Blanding Blvd, Jacksonville, FL 32244, USA",
      "poi_short_description": "Casual chain featuring BBQ & classic sides, plus memorabilia honoring soldiers & first responders.",
      "poi_long_description": "Casual chain featuring BBQ & classic sides, plus memorabilia honoring soldiers & first responders.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-6ee2-7269-b0e7-08184afcf1a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-6ee2-7269-b0e7-08184afcf1a8",
        "storage_key": "property/5713142352969728/019f14fb-6ee2-7269-b0e7-08184afcf1a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://mission-bbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2960486740134134125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-bbq",
      "poi_latitude": "30.1956826",
      "poi_longitude": "-81.7404241",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 904-712-0252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-05d2-733d-9a5b-568c18d7ebe1",
        "storage_key": "property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ8iVf4vG5YgRbQHzOwHDFSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_951c6e293691a287df5c07fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Ted's Montana Grill",
      "poi_type": "Restaurants",
      "poi_address": "8635 Blanding Blvd, Jacksonville, FL 32244, USA",
      "poi_short_description": "Old West-style steakhouse chain known for its burgers & chops made from bison.",
      "poi_long_description": "Old West-style steakhouse chain known for its burgers & chops made from bison.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-6ca7-77a9-85b4-e184d0155cd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-6ca7-77a9-85b4-e184d0155cd0",
        "storage_key": "property/5713142352969728/019f14fb-6ca7-77a9-85b4-e184d0155cd0.webp",
        "width": 600,
        "height": 450
      },
      "poi_business_url": "https://www.tedsmontanagrill.com/tmg034.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=15439225675163190951&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "teds-montana-grill",
      "poi_latitude": "30.19367",
      "poi_longitude": "-81.738556",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 904-771-1964",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-05d2-733d-9a5b-568c18d7ebe1",
        "storage_key": "property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxyBCzIvG5YgRp0Yxd_MlQ9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_7b1b725481e17e8227e75987",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "8635 Blanding Blvd, Jacksonville, FL 32244, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-8270-762d-911f-9553599ddb80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-8270-762d-911f-9553599ddb80",
        "storage_key": "property/5713142352969728/019f14fb-8270-762d-911f-9553599ddb80.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://locations.chipotle.com/fl/jacksonville/8635-blanding-blvd?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=995",
      "poi_directions_map_url": "https://maps.google.com/?cid=3594791298504996940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "30.19383569999999",
      "poi_longitude": "-81.7384472",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 904-772-1322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-05d2-733d-9a5b-568c18d7ebe1",
        "storage_key": "property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVGW4IvG5YgRTDgO1aND4zE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_b3c1edde4ee75eb5a38830fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Rocking Crab",
      "poi_type": "Restaurants",
      "poi_address": "8635 Blanding Blvd #201, Jacksonville, FL 32244, USA",
      "poi_short_description": "Casual, seafood-centric eatery offering Cajun and other specialties, plus beer, wine, and cocktails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-89f7-77e9-a54d-0794cb61ba2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-89f7-77e9-a54d-0794cb61ba2a",
        "storage_key": "property/5713142352969728/019f14fb-89f7-77e9-a54d-0794cb61ba2a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://rockingcrab.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1817512417376600425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rocking-crab",
      "poi_latitude": "30.1934722",
      "poi_longitude": "-81.73853609999999",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 904-203-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-05d2-733d-9a5b-568c18d7ebe1",
        "storage_key": "property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ65FJjU_H5YgRaQGY_OkZORk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_7f9eb0e0e00451f97041cc86",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "New China",
      "poi_type": "Restaurants",
      "poi_address": "6625 Argyle Forest Blvd #9, Jacksonville, FL 32244, USA",
      "poi_short_description": "Compact eat-in & take-out standby whipping up fried rice, egg foo yong & other Chinese standards.",
      "poi_long_description": "Compact eat-in & take-out standby whipping up fried rice, egg foo yong & other Chinese standards.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-94c0-731f-8c05-a6299e29e4b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-94c0-731f-8c05-a6299e29e4b3",
        "storage_key": "property/5713142352969728/019f14fb-94c0-731f-8c05-a6299e29e4b3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.newchina6625.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7780265870896281767&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-china",
      "poi_latitude": "30.1932382",
      "poi_longitude": "-81.751813",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 904-317-3332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-05d2-733d-9a5b-568c18d7ebe1",
        "storage_key": "property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQbX9vZbG5YgRpzjehJYO-Ws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_c3a2ea1d5e974840589e1670",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "J.L.Trent's Seafood & Grill",
      "poi_type": "Restaurants",
      "poi_address": "4553 120th St, Jacksonville, FL 32244, USA",
      "poi_short_description": "Laid-back, family-owned seafood shack serving up fish dishes & Southern sides to diners in booths.",
      "poi_long_description": "Laid-back, family-owned seafood shack serving up fish dishes & Southern sides to diners in booths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-8efd-7603-a262-33d28298a6cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-8efd-7603-a262-33d28298a6cc",
        "storage_key": "property/5713142352969728/019f14fb-8efd-7603-a262-33d28298a6cc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.jltrents.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2798238533045964891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jltrents-seafood--grill",
      "poi_latitude": "30.232523",
      "poi_longitude": "-81.70061419999999",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-908-4202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-05d2-733d-9a5b-568c18d7ebe1",
        "storage_key": "property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDwCh59rH5YgRW9ADvx5X1SY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_5e134cb392e3d39b2dd63237",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "7075 Collins Rd, Jacksonville, FL 32244, USA",
      "poi_short_description": "Discount retailer offering groceries and home goods plus electronics and clothing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-8f58-72fc-95e9-53d64c6e503c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-8f58-72fc-95e9-53d64c6e503c",
        "storage_key": "property/5713142352969728/019f14fb-8f58-72fc-95e9-53d64c6e503c.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/6978-jacksonville-fl/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17679292523577298240&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "30.2071744",
      "poi_longitude": "-81.75990209999999",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 904-365-2555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0632-75f9-9874-26dd6f0a5b52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0632-75f9-9874-26dd6f0a5b52",
        "storage_key": "property/5713142352969728/019d02f2-0632-75f9-9874-26dd6f0a5b52.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH3jedcHG5YgRQE0LnOF2WfU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_2fec77aadfe9fda75b43228a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "5466 Collins Rd, Jacksonville, FL 32244, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-9b07-7208-b848-da75ed5e9e7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-9b07-7208-b848-da75ed5e9e7e",
        "storage_key": "property/5713142352969728/019f14fb-9b07-7208-b848-da75ed5e9e7e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.familydollar.com/fl/jacksonville/5466-collins-road?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6624775436849131006&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "30.200241",
      "poi_longitude": "-81.723272",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 904-479-1757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0632-75f9-9874-26dd6f0a5b52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0632-75f9-9874-26dd6f0a5b52",
        "storage_key": "property/5713142352969728/019d02f2-0632-75f9-9874-26dd6f0a5b52.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNUWxJ0PG5YgR_i0gBinu71s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_cf1d13f33e75cfe7fad7bf5c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Daybreak Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6655 Collins Rd, Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-978b-7766-bf59-69dc3542a6c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-978b-7766-bf59-69dc3542a6c6",
        "storage_key": "property/5713142352969728/019f14fb-978b-7766-bf59-69dc3542a6c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://daybreakmarketandfuel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9756269547867140529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daybreak-market",
      "poi_latitude": "30.2048893",
      "poi_longitude": "-81.75101699999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 904-351-8972",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fc-013b-77de-9a79-3caada80579d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-013b-77de-9a79-3caada80579d",
        "storage_key": "property/5713142352969728/019f14fc-013b-77de-9a79-3caada80579d.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJFY_WRQDH5YgRsfGUfXY7ZYc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_f62125ae93315e415f3c752c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Publix Super Market at Argyle Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "6001 Argyle Forest Blvd Ste 45, Jacksonville, FL 32244, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-9401-74fb-8ae6-aa905d5df60b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-9401-74fb-8ae6-aa905d5df60b",
        "storage_key": "property/5713142352969728/019f14fb-9401-74fb-8ae6-aa905d5df60b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=649&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=307252692106570501&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-argyle-village",
      "poi_latitude": "30.1944137",
      "poi_longitude": "-81.7440711",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 904-908-5906",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-062e-7554-9772-c1e735630194.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-062e-7554-9772-c1e735630194",
        "storage_key": "property/5713142352969728/019d02f2-062e-7554-9772-c1e735630194.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-wRvD4zG5YgRBWtLEbKUQwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_fcdb1bd6b5e31749ae33a3f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Rowe's Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "5435 Blanding Blvd, Jacksonville, FL 32244, USA",
      "poi_short_description": "Grocery store selling fresh produce and seafood alongside meat and prepared foods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-9716-744e-b018-466afa9550c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-9716-744e-b018-466afa9550c2",
        "storage_key": "property/5713142352969728/019f14fb-9716-744e-b018-466afa9550c2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://rowes.iga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=717583681001754217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rowes-supermarket",
      "poi_latitude": "30.2474858",
      "poi_longitude": "-81.74150589999999",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 904-652-1640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-062e-7554-9772-c1e735630194.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-062e-7554-9772-c1e735630194",
        "storage_key": "property/5713142352969728/019d02f2-062e-7554-9772-c1e735630194.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf-CunnPH5YgRaQ66Uo5e9Qk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_264746d07d1ebc18060ebe31",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "5407 Blanding Blvd, Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-92d2-763f-ad50-3e53772a25ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-92d2-763f-ad50-3e53772a25ed",
        "storage_key": "property/5713142352969728/019f14fb-92d2-763f-ad50-3e53772a25ed.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/jacksonville-fl-pharmacies/5407-blanding-blvd-jacksonville-fl-32244/storeid=727?WT.mc_id=LS_GOOGLE_RX_727",
      "poi_directions_map_url": "https://maps.google.com/?cid=1757766273223267165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "30.247829",
      "poi_longitude": "-81.7424485",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 904-772-8884",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fc-0169-7274-bb64-38925b62dbe6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-0169-7274-bb64-38925b62dbe6",
        "storage_key": "property/5713142352969728/019f14fc-0169-7274-bb64-38925b62dbe6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBQ2lpqXH5YgRXZOiyRzXZBg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_179c76f2a06a2312777a08b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "All Well Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "5452 Blanding Blvd, Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-a20c-77b0-9eed-3a7eac918006.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-a20c-77b0-9eed-3a7eac918006",
        "storage_key": "property/5713142352969728/019f14fb-a20c-77b0-9eed-3a7eac918006.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.allwellpharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16858062231490923098&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "all-well-pharmacy",
      "poi_latitude": "30.2471671",
      "poi_longitude": "-81.7440454",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 904-779-6990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fc-0169-7274-bb64-38925b62dbe6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-0169-7274-bb64-38925b62dbe6",
        "storage_key": "property/5713142352969728/019f14fc-0169-7274-bb64-38925b62dbe6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz-r3_3LH5YgRWgpyHUje8-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_7e16c5ae9e9c0f20093bd8e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "6373 Youngerman Cir, Jacksonville, FL 32244, USA",
      "poi_short_description": "Bulk retailer offering groceries plus electronics, home furnishings and other items, along with a gas station.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-a46c-73f8-a2c9-935dabbd7540.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-a46c-73f8-a2c9-935dabbd7540",
        "storage_key": "property/5713142352969728/019f14fb-a46c-73f8-a2c9-935dabbd7540.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/6363-jacksonville-fl",
      "poi_directions_map_url": "https://maps.google.com/?cid=17341260649616996279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "30.1981391",
      "poi_longitude": "-81.74665739999999",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 904-573-9702",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0632-75f9-9874-26dd6f0a5b52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0632-75f9-9874-26dd6f0a5b52",
        "storage_key": "property/5713142352969728/019d02f2-0632-75f9-9874-26dd6f0a5b52.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP6gPppLG5YgRt3fh0a6IqPA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_dcc19633864e31c2f94ee8f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "6331 Roosevelt Blvd, Jacksonville, FL 32244, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-aa3e-77d8-b039-0994dc751142.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-aa3e-77d8-b039-0994dc751142",
        "storage_key": "property/5713142352969728/019f14fb-aa3e-77d8-b039-0994dc751142.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/ortega/1853",
      "poi_directions_map_url": "https://maps.google.com/?cid=2037242507270239114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "30.2354031",
      "poi_longitude": "-81.6943881",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-596-1065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0632-75f9-9874-26dd6f0a5b52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0632-75f9-9874-26dd6f0a5b52",
        "storage_key": "property/5713142352969728/019d02f2-0632-75f9-9874-26dd6f0a5b52.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgZtFLtnH5YgRijMrP0S9RRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_e52cef8c0e5653ed50823899",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "6001 Argyle Forest Blvd #61, Jacksonville, FL 32244, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-a743-70b2-a64d-a640136216f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-a743-70b2-a64d-a640136216f1",
        "storage_key": "property/5713142352969728/019f14fb-a743-70b2-a64d-a640136216f1.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/fl/jacksonville/6001-argyle-forest-blvd-61?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17414100183267928340&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "30.1951008",
      "poi_longitude": "-81.7439108",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 904-851-0585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0632-75f9-9874-26dd6f0a5b52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0632-75f9-9874-26dd6f0a5b52",
        "storage_key": "property/5713142352969728/019d02f2-0632-75f9-9874-26dd6f0a5b52.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-wRvD4zG5YgRFOm_UtpPq_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_a94626077c9cfbdc805a4990",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Kid City USA-Argyle",
      "poi_type": "Education",
      "poi_address": "8720 Collins Rd, Jacksonville, FL 32244, USA",
      "poi_short_description": "Daycare center offering a loving and safe environment for children.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-b08c-7698-8554-c11c41d5c624.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-b08c-7698-8554-c11c41d5c624",
        "storage_key": "property/5713142352969728/019f14fb-b08c-7698-8554-c11c41d5c624.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kidcityusa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15197323276286095832&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kid-city-usa-argyle",
      "poi_latitude": "30.2031682",
      "poi_longitude": "-81.79859189999999",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 904-717-9166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0626-75cc-8147-135d9a6091bc",
        "storage_key": "property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_2NvE-bB5YgR2PHOOwC959I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_7ee0da8ee303ab126b707b72",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Little Fountains of Light Learning Center",
      "poi_type": "Education",
      "poi_address": "7310 Collins Rd, Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-a856-714e-a133-9bb4546cf6d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-a856-714e-a133-9bb4546cf6d1",
        "storage_key": "property/5713142352969728/019f14fb-a856-714e-a133-9bb4546cf6d1.webp",
        "width": 691,
        "height": 346
      },
      "poi_business_url": "http://www.lfol.care/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12928121670452432282&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-fountains-of-light-learning-center",
      "poi_latitude": "30.2035393",
      "poi_longitude": "-81.7638138",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 904-777-2221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0626-75cc-8147-135d9a6091bc",
        "storage_key": "property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ31VjCbjG5YgRms1YxCnqabM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_5ebfc80ebfec048e95b55c15",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Sadie Tillis Elementary",
      "poi_type": "Education",
      "poi_address": "6084 Morse Ave, Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.duvalschools.org/sadietillis",
      "poi_directions_map_url": "https://maps.google.com/?cid=9762578123972436684&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sadie-tillis-elementary",
      "poi_latitude": "30.2259414",
      "poi_longitude": "-81.7407095",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 904-573-1090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0626-75cc-8147-135d9a6091bc",
        "storage_key": "property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3TO2owjH5YgRzGJgUxSle4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_6c332be62a9881b187a6199d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Chimney Lakes Elementary",
      "poi_type": "Education",
      "poi_address": "9353 Staples Mill Dr, Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.duvalschools.org/cle",
      "poi_directions_map_url": "https://maps.google.com/?cid=15708444476534279478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chimney-lakes-elementary",
      "poi_latitude": "30.1959287",
      "poi_longitude": "-81.802622",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-573-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0626-75cc-8147-135d9a6091bc",
        "storage_key": "property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3Zs_SWnB5YgRNs3FRQab_9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_768de5fd2cc3b4e09291a458",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Timucuan Elementary School",
      "poi_type": "Education",
      "poi_address": "5429 110th St, Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-b044-7146-baef-d786a35b4b6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-b044-7146-baef-d786a35b4b6c",
        "storage_key": "property/5713142352969728/019f14fb-b044-7146-baef-d786a35b4b6c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.duvalschools.org/timucuan",
      "poi_directions_map_url": "https://maps.google.com/?cid=7022004102750111091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "timucuan-elementary-school",
      "poi_latitude": "30.242086",
      "poi_longitude": "-81.7229718",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 904-573-1130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0626-75cc-8147-135d9a6091bc",
        "storage_key": "property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTwgsO73H5YgRc4XB-4Yrc2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_f54557402aec0e6735c2f14c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Argyle Christian Preschool and Kindergarten",
      "poi_type": "Education",
      "poi_address": "6823 Argyle Forest Blvd, Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://myacpk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3635034492644115328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "argyle-christian-preschool-and-kindergarten",
      "poi_latitude": "30.1936138",
      "poi_longitude": "-81.7569619",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 904-778-4838",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0626-75cc-8147-135d9a6091bc",
        "storage_key": "property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ64q_r3G5YgRgENYoJw8cjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_5b26f69550e571690104597b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Around the Clock Kid Care & Preschool",
      "poi_type": "Education",
      "poi_address": "8102 Blanding Blvd #4, Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-bcc0-777d-83d7-12710e8d2014.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-bcc0-777d-83d7-12710e8d2014",
        "storage_key": "property/5713142352969728/019f14fb-bcc0-777d-83d7-12710e8d2014.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.aroundtheclockkidcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7579413080915370023&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "around-the-clock-kid-care--preschool",
      "poi_latitude": "30.202024",
      "poi_longitude": "-81.741858",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 904-240-0947",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0626-75cc-8147-135d9a6091bc",
        "storage_key": "property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWZlXm_PG5YgRJ-DoJQp8L2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_898331bf792998633b4c2ccc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Pinedale Elementary School",
      "poi_type": "Education",
      "poi_address": "4228 Dignan St, Jacksonville, FL 32254, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://dcps.duvalschools.org/pinedale",
      "poi_directions_map_url": "https://maps.google.com/?cid=4821953231859061093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinedale-elementary-school",
      "poi_latitude": "30.324028",
      "poi_longitude": "-81.72126999999999",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 904-381-7490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0626-75cc-8147-135d9a6091bc",
        "storage_key": "property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJozE8hrC55YgRZZGBpOoE60I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_7be5a4e2ba5e66fbfae16d8b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Westside High School",
      "poi_type": "Education",
      "poi_address": "5530 Firestone Rd, Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-b021-7148-8c06-72fd0c38e061.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-b021-7148-8c06-72fd0c38e061",
        "storage_key": "property/5713142352969728/019f14fb-b021-7148-8c06-72fd0c38e061.webp",
        "width": 990,
        "height": 743
      },
      "poi_business_url": "https://dcps.duvalschools.org/o/wehs",
      "poi_directions_map_url": "https://maps.google.com/?cid=15550667930962129076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westside-high-school",
      "poi_latitude": "30.246385",
      "poi_longitude": "-81.7655426",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 904-573-1170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0626-75cc-8147-135d9a6091bc",
        "storage_key": "property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhWtnekfH5YgRtHAOnRcSz9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_2076c6c8456c25b2e3491514",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "FSCJ North Campus",
      "poi_type": "Education",
      "poi_address": "4501 Capper Rd, Jacksonville, FL 32218, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-b1c9-7705-88bb-c747418ea07b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-b1c9-7705-88bb-c747418ea07b",
        "storage_key": "property/5713142352969728/019f14fb-b1c9-7705-88bb-c747418ea07b.webp",
        "width": 1280,
        "height": 480
      },
      "poi_business_url": "https://www.fscj.edu/campuses/north-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=4623563416592959079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fscj-north-campus",
      "poi_latitude": "30.4283751",
      "poi_longitude": "-81.7176534",
      "poi_miles_from_property": "19.6 mi",
      "poi_walking_minutes": "7 hours 15 mins",
      "poi_biking_minutes": "1 hour 52 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 904-766-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0626-75cc-8147-135d9a6091bc",
        "storage_key": "property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMz2Xc8G65YgRZ8aDQm4yKkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_74ac9be645358692bca9cf92",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "AMC Regency 24",
      "poi_type": "Entertainment",
      "poi_address": "9451 Regency Square Blvd, Jacksonville, FL 32225, USA",
      "poi_short_description": "Movie theater chain in the Regency Square Mall offering 3D and IMAX films, plus reclining seats.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-bd19-72b9-a038-f6c62ad898a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-bd19-72b9-a038-f6c62ad898a7",
        "storage_key": "property/5713142352969728/019f14fb-bd19-72b9-a038-f6c62ad898a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/jacksonville/amc-regency-24?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5981426088109745154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-regency-24",
      "poi_latitude": "30.3269945",
      "poi_longitude": "-81.5548534",
      "poi_miles_from_property": "20.1 mi",
      "poi_walking_minutes": "7 hours 31 mins",
      "poi_biking_minutes": "1 hour 56 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 904-725-0885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fc-013b-77de-9a79-39b471e03247.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-013b-77de-9a79-39b471e03247",
        "storage_key": "property/5713142352969728/019f14fc-013b-77de-9a79-39b471e03247.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJMUfYhYy05YgRAiQJEFZLAlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_394776338e06f5eb0b9ecdb1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Cinemark Tinseltown Jacksonville and XD",
      "poi_type": "Entertainment",
      "poi_address": "4535 Southside Blvd, Jacksonville, FL 32216, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-c46c-705c-9b3d-11bfc6c0b2c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-c46c-705c-9b3d-11bfc6c0b2c8",
        "storage_key": "property/5713142352969728/019f14fb-c46c-705c-9b3d-11bfc6c0b2c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/fl-jacksonville/cinemark-tinseltown-jacksonville-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxNDctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8362422929890279661&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-tinseltown-jacksonville-and-xd",
      "poi_latitude": "30.2633455",
      "poi_longitude": "-81.553895",
      "poi_miles_from_property": "20.1 mi",
      "poi_walking_minutes": "7 hours 29 mins",
      "poi_biking_minutes": "2 hours 6 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 904-998-2122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fc-013b-77de-9a79-39b471e03247.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-013b-77de-9a79-39b471e03247",
        "storage_key": "property/5713142352969728/019f14fc-013b-77de-9a79-39b471e03247.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2WxdxH615YgR7QCxRVlLDXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_cff8e5d5e04e421953b7f8f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Jacksonville Zoo and Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "370 Zoo Pkwy, Jacksonville, FL 32218, USA",
      "poi_short_description": "Vast zoo highlighting local as well as African wildlife with gardens, a train & a kids' zone.",
      "poi_long_description": "Vast zoo highlighting local as well as African wildlife with gardens, a train & a kids' zone.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-bd76-7467-8a6e-113b49816bc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-bd76-7467-8a6e-113b49816bc1",
        "storage_key": "property/5713142352969728/019f14fb-bd76-7467-8a6e-113b49816bc1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.jacksonvillezoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14793728661843698434&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jacksonville-zoo-and-botanical-gardens",
      "poi_latitude": "30.4040262",
      "poi_longitude": "-81.6436476",
      "poi_miles_from_property": "18.2 mi",
      "poi_walking_minutes": "6 hours 46 mins",
      "poi_biking_minutes": "1 hour 54 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 904-757-4463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5UOOwKux5YgRAmO1YNbhTc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "ec_78b29977d0a02ddb4383f372",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Cummer Museum of Art & Gardens",
      "poi_type": "Entertainment",
      "poi_address": "829 Riverside Ave, Jacksonville, FL 32204, USA",
      "poi_short_description": "Museum showcases 5,000 works of art from all eras in a riverfront site surrounded by gardens.",
      "poi_long_description": "Museum showcases 5,000 works of art from all eras in a riverfront site surrounded by gardens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-c15d-7608-a48f-384159c3b2e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-c15d-7608-a48f-384159c3b2e6",
        "storage_key": "property/5713142352969728/019f14fb-c15d-7608-a48f-384159c3b2e6.webp",
        "width": 640,
        "height": 426
      },
      "poi_business_url": "http://www.cummermuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1730978020932146253&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cummer-museum-of-art--gardens",
      "poi_latitude": "30.3150334",
      "poi_longitude": "-81.6766992",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 904-356-6857",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0a46-75db-aa53-3596f415c552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0a46-75db-aa53-3596f415c552",
        "storage_key": "property/5713142352969728/019d02f2-0a46-75db-aa53-3596f415c552.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJrbZAOHG35YgRTVSrw1arBRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_98959659733b459e2bac3283",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "MOSH (Museum Of Science & History)",
      "poi_type": "Entertainment",
      "poi_address": "1025 Museum Cir, Jacksonville, FL 32207, USA",
      "poi_short_description": "Aquariums & exhibits on the body, marine mammals & energy are featured at this popular museum.",
      "poi_long_description": "Aquariums & exhibits on the body, marine mammals & energy are featured at this popular museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-d217-74ea-8c07-f74498b0457c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-d217-74ea-8c07-f74498b0457c",
        "storage_key": "property/5713142352969728/019f14fb-d217-74ea-8c07-f74498b0457c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://themosh.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7369837136756052471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mosh-museum-of-science--history",
      "poi_latitude": "30.31886519999999",
      "poi_longitude": "-81.65976669999999",
      "poi_miles_from_property": "12.2 mi",
      "poi_walking_minutes": "4 hours 33 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 904-396-6674",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0a46-75db-aa53-3596f415c552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0a46-75db-aa53-3596f415c552",
        "storage_key": "property/5713142352969728/019d02f2-0a46-75db-aa53-3596f415c552.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJn1gEIRC35YgR95HTLNTrRmY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_2738e0db1a5756a15d6274ff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "MOCA (Museum Of Contemporary Art), Jacksonville",
      "poi_type": "Entertainment",
      "poi_address": "333 N Laura St, Jacksonville, FL 32202, USA",
      "poi_short_description": "Art museum features changing exhibition galleries along with permanent works & a children's area.",
      "poi_long_description": "Art museum features changing exhibition galleries along with permanent works & a children's area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-c7fa-750b-8dc4-dccf617ff5ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-c7fa-750b-8dc4-dccf617ff5ba",
        "storage_key": "property/5713142352969728/019f14fb-c7fa-750b-8dc4-dccf617ff5ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://mocajacksonville.unf.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7538781776723524810&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moca-museum-of-contemporary-art-jacksonville",
      "poi_latitude": "30.3292778",
      "poi_longitude": "-81.65840829999999",
      "poi_miles_from_property": "12.1 mi",
      "poi_walking_minutes": "4 hours 31 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 904-620-1214",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0a46-75db-aa53-3596f415c552.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0a46-75db-aa53-3596f415c552",
        "storage_key": "property/5713142352969728/019d02f2-0a46-75db-aa53-3596f415c552.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9T209Be35YgRyjzLcBUin2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_68d947d28e86a90ba357c00a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Daily's Place",
      "poi_type": "Entertainment",
      "poi_address": "1 Daily’s Place, Jacksonville, FL 32202, USA",
      "poi_short_description": "Modern outdoor performing-arts center with 5,500 seats hosting a variety of live concerts & events.",
      "poi_long_description": "Modern outdoor performing-arts center with 5,500 seats hosting a variety of live concerts & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-d28b-720a-8cc1-4c4de7b0b646.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-d28b-720a-8cc1-4c4de7b0b646",
        "storage_key": "property/5713142352969728/019f14fb-d28b-720a-8cc1-4c4de7b0b646.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://dailysplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4625248249833615800&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dailys-place",
      "poi_latitude": "30.3221236",
      "poi_longitude": "-81.63784679999999",
      "poi_miles_from_property": "13.3 mi",
      "poi_walking_minutes": "4 hours 56 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 904-633-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLX4Srei25YgRuHFUEccuMEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "ec_0598aa09691e630fe1e97ed7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Decca Live",
      "poi_type": "Entertainment",
      "poi_address": "323 E Bay St, Jacksonville, FL 32202, USA",
      "poi_short_description": "Nightclub and event space featuring live rock bands and EDM artists as well as DJs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-cd14-7758-bc57-8b577b4f7aaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-cd14-7758-bc57-8b577b4f7aaf",
        "storage_key": "property/5713142352969728/019f14fb-cd14-7758-bc57-8b577b4f7aaf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://deccalive.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16693335210512255582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "decca-live",
      "poi_latitude": "30.325537",
      "poi_longitude": "-81.653601",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 35 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 904-822-8284",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3We_TwC35YgRXooay-2jquc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "concert_hall"
    },
    {
      "id": "ec_3c4f177c2ef8b9f10e1029c2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Riverside Arts Market",
      "poi_type": "Entertainment",
      "poi_address": "715 Riverside Ave, Jacksonville, FL 32204, USA",
      "poi_short_description": "Lively market held Saturdays under the bridge featuring local artists, food vendors & entertainment.",
      "poi_long_description": "Lively market held Saturdays under the bridge featuring local artists, food vendors & entertainment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-d98a-741c-bf57-eed211339b1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-d98a-741c-bf57-eed211339b1d",
        "storage_key": "property/5713142352969728/019f14fb-d98a-741c-bf57-eed211339b1d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://riversideartsmarket.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=214201419467524069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverside-arts-market",
      "poi_latitude": "30.316298",
      "poi_longitude": "-81.6756949",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 56 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 904-389-2449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0632-75f9-9874-26dd6f0a5b52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0632-75f9-9874-26dd6f0a5b52",
        "storage_key": "property/5713142352969728/019d02f2-0632-75f9-9874-26dd6f0a5b52.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTZDpDXG35YgR5Qe_XQ7_-AI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farmers_market"
    },
    {
      "id": "ec_defc05311f80af97a9f6c220",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Topgolf Jacksonville",
      "poi_type": "Entertainment",
      "poi_address": "10531 Brightman Blvd, Jacksonville, FL 32246, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-cb11-72d9-aaca-68133f052c19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-cb11-72d9-aaca-68133f052c19",
        "storage_key": "property/5713142352969728/019f14fb-cb11-72d9-aaca-68133f052c19.webp",
        "width": 1000,
        "height": 720
      },
      "poi_business_url": "https://topgolf.com/us/jacksonville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=551425716930125462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-jacksonville",
      "poi_latitude": "30.2632674",
      "poi_longitude": "-81.5205175",
      "poi_miles_from_property": "22.9 mi",
      "poi_walking_minutes": "8 hours 31 mins",
      "poi_biking_minutes": "2 hours 19 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 904-328-2002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-05d2-733d-9a5b-568c18d7ebe1",
        "storage_key": "property/5713142352969728/019d02f2-05d2-733d-9a5b-568c18d7ebe1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPUWBGFK15YgRlp6imcQOpwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_b52cd2f75227c768c19ec94f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "HCA Florida Park West Emergency",
      "poi_type": "Health and Wellness",
      "poi_address": "6477 103rd St, Jacksonville, FL 32210, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-cb7c-775d-913b-79f551d3ff14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-cb7c-775d-913b-79f551d3ff14",
        "storage_key": "property/5713142352969728/019f14fb-cb7c-775d-913b-79f551d3ff14.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hcafloridahealthcare.com/locations/orange-park-hospital/specialties/emergency-care/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=9906656502538079935&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-florida-park-west-emergency",
      "poi_latitude": "30.2489426",
      "poi_longitude": "-81.7488121",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 904-772-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUbWLNGzH5YgRv46Y8ZmDe4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_3b47ad1769a28cf44b6ba749",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "MD Now Urgent Care - Collins Rd",
      "poi_type": "Health and Wellness",
      "poi_address": "7075 Collins Rd Unit 100, Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-cb2c-74f9-aaf3-6b7cb8f91190.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-cb2c-74f9-aaf3-6b7cb8f91190",
        "storage_key": "property/5713142352969728/019f14fb-cb2c-74f9-aaf3-6b7cb8f91190.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mymdnow.com/locations/jacksonville/collins-rd?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=465972101008888055&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "md-now-urgent-care---collins-rd",
      "poi_latitude": "30.2067828",
      "poi_longitude": "-81.7608769",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 904-486-7280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0SA-tnH5YgR95DgMyh3dwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_cab1e0206efc63aba3a14d77",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "7075 Collins Rd, Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-d613-77bb-8ba1-cfa41593594e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-d613-77bb-8ba1-cfa41593594e",
        "storage_key": "property/5713142352969728/019f14fb-d613-77bb-8ba1-cfa41593594e.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/6978-jacksonville-fl/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16972551872743078779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "30.2071744",
      "poi_longitude": "-81.75990209999999",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 904-365-2552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fc-0169-7274-bb64-38925b62dbe6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-0169-7274-bb64-38925b62dbe6",
        "storage_key": "property/5713142352969728/019f14fc-0169-7274-bb64-38925b62dbe6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlaLfdcHG5YgRe_u9-gCeius",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_09973e1b0e3bf1236e11fda4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Baptist & Wolfson Oakleaf Emergency Room (ER)",
      "poi_type": "Health and Wellness",
      "poi_address": "9868 Family Pl, Jacksonville, FL 32222, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-db28-7166-9687-ad77ac6b37c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-db28-7166-9687-ad77ac6b37c1",
        "storage_key": "property/5713142352969728/019f14fb-db28-7166-9687-ad77ac6b37c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.baptistjax.com/immediate-care/er/baptist-oakleaf-er",
      "poi_directions_map_url": "https://maps.google.com/?cid=17561278594450180023&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist--wolfson-oakleaf-emergency-room-er",
      "poi_latitude": "30.1968154",
      "poi_longitude": "-81.83404329999999",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 904-516-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs9F1f5TB5YgRt8ffh9YxtvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_2ec0a6c3db044aad004f6a21",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Westland Park Plaza",
      "poi_type": "Health and Wellness",
      "poi_address": "6000 Lake Gray Blvd, Jacksonville, FL 32244, USA",
      "poi_short_description": "Stores for clothing and footwear, plus music stores, fitness centers and thrift shops.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-d9ef-77d4-bcd6-cb0e1d630af6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-d9ef-77d4-bcd6-cb0e1d630af6",
        "storage_key": "property/5713142352969728/019f14fb-d9ef-77d4-bcd6-cb0e1d630af6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mgoldgroup.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10548999708495431165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westland-park-plaza",
      "poi_latitude": "30.1991511",
      "poi_longitude": "-81.74114349999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 813-406-5819",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0632-75f9-9874-26dd6f0a5b52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0632-75f9-9874-26dd6f0a5b52",
        "storage_key": "property/5713142352969728/019d02f2-0632-75f9-9874-26dd6f0a5b52.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIRGJwfbH5YgR_cWRCFiTZZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_1f48e99e90b11170e9c4a627",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1980 Wells Rd, Orange Park, FL 32073, USA",
      "poi_short_description": "Clean spot with a relaxed atmosphere offering hydro-massage beds and tanning booths.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14f8-55fc-76eb-8de6-cd4700a2f28b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-55fc-76eb-8de6-cd4700a2f28b",
        "storage_key": "property/5713142352969728/019f14f8-55fc-76eb-8de6-cd4700a2f28b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/jacksonville-orange-park-fl?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042208244049428992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "30.1865286",
      "poi_longitude": "-81.74127709999999",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 904-272-2224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2-OO-oXG5YgRAMLkNBbzumE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_fcb32eb93c16c1076dc21a48",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "7790 Blanding Blvd, Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-92d2-763f-ad50-3e53772a25ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-92d2-763f-ad50-3e53772a25ed",
        "storage_key": "property/5713142352969728/019f14fb-92d2-763f-ad50-3e53772a25ed.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/jacksonville-fl-pharmacies/7790-blanding-blvd-jacksonville-fl-32244/storeid=3685?WT.mc_id=LS_GOOGLE_RX_3685",
      "poi_directions_map_url": "https://maps.google.com/?cid=3241541991481040592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "30.2048289",
      "poi_longitude": "-81.74022509999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 904-771-0571",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fc-0169-7274-bb64-38925b62dbe6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-0169-7274-bb64-38925b62dbe6",
        "storage_key": "property/5713142352969728/019f14fc-0169-7274-bb64-38925b62dbe6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUxedrfbG5YgR0F69TkRF_Cw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_8cdf18f4b601b6b07a094ce6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "630 Blanding Blvd, Orange Park, FL 32073, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-df84-7318-bd1e-0711c4466ac8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-df84-7318-bd1e-0711c4466ac8",
        "storage_key": "property/5713142352969728/019f14fb-df84-7318-bd1e-0711c4466ac8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-630+blanding+blvd-orange+park-fl-32073/id=4081",
      "poi_directions_map_url": "https://maps.google.com/?cid=17517708556947203919&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "30.1509379",
      "poi_longitude": "-81.7531569",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 904-272-3750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ007I40DE5YgRT6eopx5nG_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_c8f68e78bf70863ce2ab4793",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Yoga Den Oakleaf",
      "poi_type": "Health and Wellness",
      "poi_address": "8540 Argyle Forest Blvd Unit 7, Jacksonville, FL 32244, USA",
      "poi_short_description": "Yoga studio featuring heated classes, reiki, meditation and mind-body classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-dbe1-7200-9971-5bfb5663f485.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-dbe1-7200-9971-5bfb5663f485",
        "storage_key": "property/5713142352969728/019f14fb-dbe1-7200-9971-5bfb5663f485.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://yoga-den.com/location/oakleaf/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17058906767043604564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yoga-den-oakleaf",
      "poi_latitude": "30.1935234",
      "poi_longitude": "-81.7948203",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 904-750-1676",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0626-75cc-8147-135d9a6091bc",
        "storage_key": "property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp29DikzB5YgRVDAkmlJpvew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_cdde1523d61591b65f09a84b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9610 Applecross Rd #102, Jacksonville, FL 32222, USA",
      "poi_short_description": "Heart-rate-based group workouts combining strength and cardio training, led by coaches.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-e3bf-7524-9db5-5b457c415935.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-e3bf-7524-9db5-5b457c415935",
        "storage_key": "property/5713142352969728/019f14fb-e3bf-7524-9db5-5b457c415935.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/jacksonville-florida-0898?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=7002010978919040075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "30.1964625",
      "poi_longitude": "-81.82715759999999",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-661-1958",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW3_xbZzB5YgRS8TaF-MjLGE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_7951c5361703242828318ced",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Tillie K. Fowler Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7000 Roosevelt Blvd, Jacksonville, FL 32244, USA",
      "poi_short_description": "Wooded hiking trails & boardwalks, plus a playground, visitors center & observation tower.",
      "poi_long_description": "Wooded hiking trails & boardwalks, plus a playground, visitors center & observation tower.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f1-e7ce-753a-a4df-e3b0d3b3ed66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f1-e7ce-753a-a4df-e3b0d3b3ed66",
        "storage_key": "property/5713142352969728/019d02f1-e7ce-753a-a4df-e3b0d3b3ed66.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/tillie-k--fowler-regional-park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=5065540089645363929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tillie-k-fowler-regional-park",
      "poi_latitude": "30.239419",
      "poi_longitude": "-81.7023825",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-573-2498",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0cb7-758d-8a87-ac36317078f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0cb7-758d-8a87-ac36317078f3",
        "storage_key": "property/5713142352969728/019d02f2-0cb7-758d-8a87-ac36317078f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJv4qWYc3H5YgR2fLPht9pTEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_5607675935a1e9a58c88f99c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Ringhaver Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5198 118th St, Jacksonville, FL 32244, USA",
      "poi_short_description": "Large park featuring a riverfront boardwalk & canoe/kayak launch plus play equipment & picnic areas.",
      "poi_long_description": "Large park featuring a riverfront boardwalk & canoe/kayak launch plus play equipment & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14f8-6d55-73d4-a436-f9802d70cbda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-6d55-73d4-a436-f9802d70cbda",
        "storage_key": "property/5713142352969728/019f14f8-6d55-73d4-a436-f9802d70cbda.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/ringhaver-park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=17496436952949367230&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ringhaver-park",
      "poi_latitude": "30.228882",
      "poi_longitude": "-81.71772299999999",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-779-7462",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0cb7-758d-8a87-ac36317078f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0cb7-758d-8a87-ac36317078f3",
        "storage_key": "property/5713142352969728/019d02f2-0cb7-758d-8a87-ac36317078f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ03Su5LbH5YgRvqGQZ7XUz_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_9d520e49f07727c1ac0e851d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "McGirts Creek Community Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8435 118th St, Jacksonville, FL 32244, USA",
      "poi_short_description": "Kid-friendly park featuring a pond and a clean, large playground, along with picnic tables, baseball fields and soccer fields, plus a trail for walking and biking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-e543-768f-b569-2896bec03f0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-e543-768f-b569-2896bec03f0b",
        "storage_key": "property/5713142352969728/019f14fb-e543-768f-b569-2896bec03f0b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/community-centers-(1)/mcgirts-creek-community-center-and-lew-brantley-pa",
      "poi_directions_map_url": "https://maps.google.com/?cid=831063654513775613&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcgirts-creek-community-center",
      "poi_latitude": "30.23728869999999",
      "poi_longitude": "-81.79207799999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-573-3153",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJASI7NcXA5YgR_RMImf2HiAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "ec_d65d7005ff8c1c6381ea6824",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Jammes Road Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6382 118th St, Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-e187-750c-9f3c-1899bffb92d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-e187-750c-9f3c-1899bffb92d6",
        "storage_key": "property/5713142352969728/019f14fb-e187-750c-9f3c-1899bffb92d6.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/jammes-road-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=475443710021761151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jammes-road-park",
      "poi_latitude": "30.233398",
      "poi_longitude": "-81.747346",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0cb7-758d-8a87-ac36317078f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0cb7-758d-8a87-ac36317078f3",
        "storage_key": "property/5713142352969728/019d02f2-0cb7-758d-8a87-ac36317078f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIzILYpLH5YgRf3iKBokdmQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d1fde2169edeaebe679a7b23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Wesconnett Elementary School Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6045 Malcone Ln, Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-e5a7-75fb-9b4f-1ff81b008e4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-e5a7-75fb-9b4f-1ff81b008e4a",
        "storage_key": "property/5713142352969728/019f14fb-e5a7-75fb-9b4f-1ff81b008e4a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9990156818238916172&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wesconnett-elementary-school-park",
      "poi_latitude": "30.245631",
      "poi_longitude": "-81.73992299999999",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 904-479-9221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0cb7-758d-8a87-ac36317078f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0cb7-758d-8a87-ac36317078f3",
        "storage_key": "property/5713142352969728/019d02f2-0cb7-758d-8a87-ac36317078f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJO3iFonTH5YgRTMaTMbIqpIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_eba09a067489e2e029cdeb67",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Wayne B. Stevens Boat Ramp",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4555 Ortega Farms Blvd, Jacksonville, FL 32210, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-e5b3-714a-874a-81d185f4468c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-e5b3-714a-874a-81d185f4468c",
        "storage_key": "property/5713142352969728/019f14fb-e5b3-714a-874a-81d185f4468c.webp",
        "width": 1280,
        "height": 1028
      },
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/wayne-b-stevens-boat-ramp",
      "poi_directions_map_url": "https://maps.google.com/?cid=13375153154328981225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wayne-b-stevens-boat-ramp",
      "poi_latitude": "30.2597827",
      "poi_longitude": "-81.7264562",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYmjNITH5YgR6W455O0Wnrk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_b343aa2e9f822e3625baa454",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Westwood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5931 Tampico Rd, Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/westwood-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=58435595921818671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westwood-park",
      "poi_latitude": "30.2416674",
      "poi_longitude": "-81.7564459",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0cb7-758d-8a87-ac36317078f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0cb7-758d-8a87-ac36317078f3",
        "storage_key": "property/5713142352969728/019d02f2-0cb7-758d-8a87-ac36317078f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDZK6fKjH5YgRL4Qoad2azwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0b4dc8ba203b170b42c0c21c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Tillie K. Fowler Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7000 Roosevelt Blvd, Jacksonville, FL 32244, USA",
      "poi_short_description": "Wooded hiking trails & boardwalks, plus a playground, visitors center & observation tower.",
      "poi_long_description": "Wooded hiking trails & boardwalks, plus a playground, visitors center & observation tower.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f1-e7ce-753a-a4df-e3b0d3b3ed66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02f1-e7ce-753a-a4df-e3b0d3b3ed66",
        "storage_key": "property/5713142352969728/019d02f1-e7ce-753a-a4df-e3b0d3b3ed66.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/tillie-k--fowler-regional-park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=5065540089645363929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tillie-k-fowler-regional-park",
      "poi_latitude": "30.239419",
      "poi_longitude": "-81.7023825",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 904-573-2498",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0cb7-758d-8a87-ac36317078f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0cb7-758d-8a87-ac36317078f3",
        "storage_key": "property/5713142352969728/019d02f2-0cb7-758d-8a87-ac36317078f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJv4qWYc3H5YgR2fLPht9pTEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2ac69d8a59b57993b8dd8248",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Timuquana Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4541 Timuquana Rd, Jacksonville, FL 32210, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-ec46-7504-9569-4d2fe1615e07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-ec46-7504-9569-4d2fe1615e07",
        "storage_key": "property/5713142352969728/019f14fb-ec46-7504-9569-4d2fe1615e07.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5739287872890856103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "timuquana-park",
      "poi_latitude": "30.2479497",
      "poi_longitude": "-81.69874709999999",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 904-771-3490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0cb7-758d-8a87-ac36317078f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0cb7-758d-8a87-ac36317078f3",
        "storage_key": "property/5713142352969728/019d02f2-0cb7-758d-8a87-ac36317078f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCb8gMIzH5YgRp-Jdj-kLpk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_381513ceb5ba4cb30eb217e2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Ortega Hills Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4791 Ortega Hills Dr, Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.coj.net/departments/parks-and-recreation/recreation-and-community-programming/parks/ortega-hills-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9411941601131743554&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ortega-hills-park",
      "poi_latitude": "30.2187083",
      "poi_longitude": "-81.7054385",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0cb7-758d-8a87-ac36317078f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0cb7-758d-8a87-ac36317078f3",
        "storage_key": "property/5713142352969728/019d02f2-0cb7-758d-8a87-ac36317078f3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiwXjtYfH5YgRQsktBgXvnYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_970013581066a5470692e723",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Blanding Blvd. & Collins Rd.",
      "poi_type": "Transportation & Transit",
      "poi_address": "Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17826549792012236041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blanding-blvd--collins-rd",
      "poi_latitude": "30.205284",
      "poi_longitude": "-81.73931",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_cMJvfbG5YgRCfWzM5agZPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_69912c2d8174eb4c117752d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Blanding Blvd & 103rd St",
      "poi_type": "Transportation & Transit",
      "poi_address": "Jacksonville, FL 32244, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11279151390634242702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blanding-blvd--103rd-st",
      "poi_latitude": "30.2472153",
      "poi_longitude": "-81.7428963",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqSAxsnPH5YgRjnKbJm6Yh5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_75354ce3215018e3c8da5cbc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Jacksonville International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Yankee Clipper Dr, Jacksonville, FL 32218, USA",
      "poi_short_description": "This airport with on-site lodging also features 2 art galleries with rotating exhibitions.",
      "poi_long_description": "This airport with on-site lodging also features 2 art galleries with rotating exhibitions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-e7a9-74ca-ae38-c9e7b9e9ac22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-e7a9-74ca-ae38-c9e7b9e9ac22",
        "storage_key": "property/5713142352969728/019f14fb-e7a9-74ca-ae38-c9e7b9e9ac22.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.flyjacksonville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1871272610310749030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jacksonville-international-airport",
      "poi_latitude": "30.4943308",
      "poi_longitude": "-81.68714969999999",
      "poi_miles_from_property": "24.2 mi",
      "poi_walking_minutes": "8 hours 57 mins",
      "poi_biking_minutes": "2 hours 23 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 904-741-4902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fc-0174-766f-b095-da1489098641.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-0174-766f-b095-da1489098641",
        "storage_key": "property/5713142352969728/019f14fc-0174-766f-b095-da1489098641.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0IKb3-v5YgRZnt9T4YY-Bk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_ba278e7a3777044bcbc161c0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "JRTC - Jacksonville Regional Transportation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "100 LaVilla Center Drive, Jacksonville, FL 32204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-e9f2-70a2-91b2-d8485db70c86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-e9f2-70a2-91b2-d8485db70c86",
        "storage_key": "property/5713142352969728/019f14fb-e9f2-70a2-91b2-d8485db70c86.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14905535492629981391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jrtc---jacksonville-regional-transportation-center",
      "poi_latitude": "30.3290687",
      "poi_longitude": "-81.6724579",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 16 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHS8mSk635YgRz-gvwY4Z284",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_7d2578673f5d1bce7908921f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Rosa L. Parks Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "Jacksonville, FL 32202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-eacc-75bc-bd17-652b47351f1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-eacc-75bc-bd17-652b47351f1c",
        "storage_key": "property/5713142352969728/019f14fb-eacc-75bc-bd17-652b47351f1c.webp",
        "width": 1280,
        "height": 941
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3752237747953373739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosa-l-parks-transit",
      "poi_latitude": "30.333289",
      "poi_longitude": "-81.65871",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 36 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJheZBKT235YgRK5KS_1mgEjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_3333c6338538ea1ec6b399b3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Jacksonville",
      "poi_type": "Transportation & Transit",
      "poi_address": "3570 Clifford Ln, Jacksonville, FL 32209, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-ec46-7504-9569-53dcc184211b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-ec46-7504-9569-53dcc184211b",
        "storage_key": "property/5713142352969728/019f14fb-ec46-7504-9569-53dcc184211b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/stations/jax",
      "poi_directions_map_url": "https://maps.google.com/?cid=7671518193627583878&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jacksonville",
      "poi_latitude": "30.3656",
      "poi_longitude": "-81.72389",
      "poi_miles_from_property": "13.0 mi",
      "poi_walking_minutes": "4 hours 51 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_2UPjyW65YgRhlUe0ya1dmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_07c464cf83cf609645d6d0a8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Avenues Walk Park-n-Ride Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "10508 Avenues Walk Blvd, Jacksonville, FL 32258, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-ed8c-76b0-ad4f-be83712c98f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-ed8c-76b0-ad4f-be83712c98f0",
        "storage_key": "property/5713142352969728/019f14fb-ed8c-76b0-ad4f-be83712c98f0.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.jtafla.com/ride-jta/how-to-ride/park-n-ride/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1058484284830957639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "avenues-walk-park-n-ride-center",
      "poi_latitude": "30.1764331",
      "poi_longitude": "-81.5530462",
      "poi_miles_from_property": "24.9 mi",
      "poi_walking_minutes": "9 hours 17 mins",
      "poi_biking_minutes": "2 hours 22 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 904-630-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKUBbmzfL5YgRR8CuVdl9sA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_65ed5868531d75869ca7a0c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Armsdale Park-n-Ride (JTA)",
      "poi_type": "Transportation & Transit",
      "poi_address": "3191 Armsdale Rd, Jacksonville, FL 32218, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-ee4c-73a7-afb6-63977c1dd95d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-ee4c-73a7-afb6-63977c1dd95d",
        "storage_key": "property/5713142352969728/019f14fb-ee4c-73a7-afb6-63977c1dd95d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jtafla.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14051231981880624069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "armsdale-park-n-ride-jta",
      "poi_latitude": "30.4537234",
      "poi_longitude": "-81.70277879999999",
      "poi_miles_from_property": "20.1 mi",
      "poi_walking_minutes": "7 hours 29 mins",
      "poi_biking_minutes": "1 hour 54 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 904-630-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fc-013f-773c-a4a2-f0b041075f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-013f-773c-a4a2-f0b041075f87",
        "storage_key": "property/5713142352969728/019f14fc-013f-773c-a4a2-f0b041075f87.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJQWhS402l5YgRxUOaeAoBAMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_e55839f7d2096c35b2f058a6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Kings Avenue Parking Garage (JTA)",
      "poi_type": "Transportation & Transit",
      "poi_address": "1201 Kings Ave, Jacksonville, FL 32207, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-f128-75ea-aba7-6086acb863f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-f128-75ea-aba7-6086acb863f8",
        "storage_key": "property/5713142352969728/019f14fb-f128-75ea-aba7-6086acb863f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://jtafla.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10036788076318921754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kings-avenue-parking-garage-jta",
      "poi_latitude": "30.312755",
      "poi_longitude": "-81.6526228",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 33 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 904-630-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fc-013f-773c-a4a2-f0b041075f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-013f-773c-a4a2-f0b041075f87",
        "storage_key": "property/5713142352969728/019f14fc-013f-773c-a4a2-f0b041075f87.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJU2Oj4uK35YgRGpTdBpTVSYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_garage"
    },
    {
      "id": "ec_b6e49f32e326e04bc5003f0b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Mayo Clinic",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4500 San Pablo Rd S, Jacksonville, FL 32224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-f128-75ea-aba7-67f83c24bf65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-f128-75ea-aba7-67f83c24bf65",
        "storage_key": "property/5713142352969728/019f14fb-f128-75ea-aba7-67f83c24bf65.webp",
        "width": 929,
        "height": 523
      },
      "poi_business_url": "http://www.mayoclinic.org/patient-visitor-guide/florida/campus-buildings-maps/mayo-building-hospital?mc_id=us&utm_source=yext&utm_medium=l&utm_content=feature&utm_campaign=mayoclinic&geo=national&placementsite=enterprise&invsrc=other&cauid=102372&y_source=1_MzkxODQ2OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2898705910926404099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mayo-clinic",
      "poi_latitude": "30.2640897",
      "poi_longitude": "-81.4409507",
      "poi_miles_from_property": "27.8 mi",
      "poi_walking_minutes": "10 hours 23 mins",
      "poi_biking_minutes": "2 hours 50 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 904-953-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0aea-733f-9112-ea090dcb30bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0aea-733f-9112-ea090dcb30bc",
        "storage_key": "property/5713142352969728/019d02f2-0aea-733f-9112-ea090dcb30bc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJk5xKnQ3K5YgRA-oXAatFOig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_8729560fb0d0f61bed06d16e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "UF Health Jacksonville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "655 8th St W, Jacksonville, FL 32209, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-f173-7250-b3ee-98d7ac39c77f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-f173-7250-b3ee-98d7ac39c77f",
        "storage_key": "property/5713142352969728/019f14fb-f173-7250-b3ee-98d7ac39c77f.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://ufhealthjax.org/locations/uf-health-jacksonville?utm_source=pg-google&utm_medium=organic&utm_campaign=pg-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=18323229800635225191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uf-health-jacksonville",
      "poi_latitude": "30.3482365",
      "poi_longitude": "-81.66335629999999",
      "poi_miles_from_property": "13.0 mi",
      "poi_walking_minutes": "4 hours 52 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 904-244-0411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0aea-733f-9112-ea090dcb30bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0aea-733f-9112-ea090dcb30bc",
        "storage_key": "property/5713142352969728/019d02f2-0aea-733f-9112-ea090dcb30bc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJL3HhAzS35YgRZ9S2TGwwSf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_b07d790b45b3e3dd81b9f8bf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Baptist Medical Center Jacksonville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "800 Prudential Dr, Jacksonville, FL 32207, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-f614-72d5-ad3d-c86238bf6ffe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-f614-72d5-ad3d-c86238bf6ffe",
        "storage_key": "property/5713142352969728/019f14fb-f614-72d5-ad3d-c86238bf6ffe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.baptistjax.com/locations/baptist-medical-center-jacksonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=8263115339206629753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-medical-center-jacksonville",
      "poi_latitude": "30.3161141",
      "poi_longitude": "-81.6631088",
      "poi_miles_from_property": "12.0 mi",
      "poi_walking_minutes": "4 hours 27 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 904-202-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0aea-733f-9112-ea090dcb30bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0aea-733f-9112-ea090dcb30bc",
        "storage_key": "property/5713142352969728/019d02f2-0aea-733f-9112-ea090dcb30bc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyXVwHwy35YgReRl-A597rHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_1cb04322dc19ce0f8ead4da0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "University of North Florida (UNF)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 UNF Dr., Jacksonville, FL 32224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-f54d-700b-b00d-6249e75813ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-f54d-700b-b00d-6249e75813ca",
        "storage_key": "property/5713142352969728/019f14fb-f54d-700b-b00d-6249e75813ca.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.unf.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18226157899370904914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-florida-unf",
      "poi_latitude": "30.2661204",
      "poi_longitude": "-81.50723140000001",
      "poi_miles_from_property": "23.0 mi",
      "poi_walking_minutes": "8 hours 35 mins",
      "poi_biking_minutes": "2 hours 25 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 904-620-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0626-75cc-8147-135d9a6091bc",
        "storage_key": "property/5713142352969728/019d02f2-0626-75cc-8147-135d9a6091bc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU2DTHbRK5IgRUr0uDAtS8Pw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_29cb8537d978c042376264ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "NAS Jax",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6801 Roosevelt Blvd, Jacksonville, FL 32212, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-f746-7454-a648-3d7bdfc279dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-f746-7454-a648-3d7bdfc279dc",
        "storage_key": "property/5713142352969728/019f14fb-f746-7454-a648-3d7bdfc279dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cnrse.cnic.navy.mil/Installations/NAS-Jacksonville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9352013036945703449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nas-jax",
      "poi_latitude": "30.2257225",
      "poi_longitude": "-81.7001854",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 904-542-2338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-1206-746d-b3c7-edb31e85748b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-1206-746d-b3c7-edb31e85748b",
        "storage_key": "property/5713142352969728/019d02f2-1206-746d-b3c7-edb31e85748b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBVuBltHH5YgRGYL42U4GyYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_27df8e6607695385a76ddd58",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "CSX Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 Water St #4445, Jacksonville, FL 32202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-f6df-71fa-ab91-ea223bcc9d23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-f6df-71fa-ab91-ea223bcc9d23",
        "storage_key": "property/5713142352969728/019f14fb-f6df-71fa-ab91-ea223bcc9d23.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.csx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12013208524298938918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "csx-corporation",
      "poi_latitude": "30.3242164",
      "poi_longitude": "-81.6640066",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 24 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 904-359-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBcgd-RO35YgRJmqID4F9t6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_a954105ea1a7b24d7943e417",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "FIS",
      "poi_type": "Major Employers & Offices",
      "poi_address": "347 Riverside Ave, Jacksonville, FL 32204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-f66e-742e-b71b-fd99ab521ec1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-f66e-742e-b71b-fd99ab521ec1",
        "storage_key": "property/5713142352969728/019f14fb-f66e-742e-b71b-fd99ab521ec1.webp",
        "width": 884,
        "height": 584
      },
      "poi_business_url": "https://www.fisglobal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5382664508797814060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fis",
      "poi_latitude": "30.3210514",
      "poi_longitude": "-81.6730915",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 5 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 904-438-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-0bc6-72bd-9bea-bb47aba4ed10",
        "storage_key": "property/5713142352969728/019d02f2-0bc6-72bd-9bea-bb47aba4ed10.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwoIH3K35YgRLAX_J9oQs0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_a76c5f413535962edec70bc1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Jacksonville International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2400 Yankee Clipper Dr, Jacksonville, FL 32218, USA",
      "poi_short_description": "This airport with on-site lodging also features 2 art galleries with rotating exhibitions.",
      "poi_long_description": "This airport with on-site lodging also features 2 art galleries with rotating exhibitions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-e7a9-74ca-ae38-c9e7b9e9ac22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-e7a9-74ca-ae38-c9e7b9e9ac22",
        "storage_key": "property/5713142352969728/019f14fb-e7a9-74ca-ae38-c9e7b9e9ac22.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.flyjacksonville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1871272610310749030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jacksonville-international-airport",
      "poi_latitude": "30.4943308",
      "poi_longitude": "-81.68714969999999",
      "poi_miles_from_property": "24.2 mi",
      "poi_walking_minutes": "8 hours 57 mins",
      "poi_biking_minutes": "2 hours 23 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 904-741-4902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fc-0174-766f-b095-da1489098641.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fc-0174-766f-b095-da1489098641",
        "storage_key": "property/5713142352969728/019f14fc-0174-766f-b095-da1489098641.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0IKb3-v5YgRZnt9T4YY-Bk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_2a6d5630aa7be2b66aa1b478",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "JAXPORT Corporate Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2831 Talleyrand Ave, Jacksonville, FL 32206, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-f8d3-7287-a6bc-da6d014a2c39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-f8d3-7287-a6bc-da6d014a2c39",
        "storage_key": "property/5713142352969728/019f14fb-f8d3-7287-a6bc-da6d014a2c39.webp",
        "width": 502,
        "height": 313
      },
      "poi_business_url": "http://www.jaxport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8978070890287588599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jaxport-corporate-headquarters",
      "poi_latitude": "30.3562351",
      "poi_longitude": "-81.6249954",
      "poi_miles_from_property": "15.8 mi",
      "poi_walking_minutes": "5 hours 53 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 904-357-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-1206-746d-b3c7-edb31e85748b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-1206-746d-b3c7-edb31e85748b",
        "storage_key": "property/5713142352969728/019d02f2-1206-746d-b3c7-edb31e85748b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJadHjj-Cy5YgR9-TdJ-iDmHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_b77b76e4b50b4802a8e648b6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "poi_name": "Jacksonville City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "117 W Duval St, Jacksonville, FL 32202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14fb-facd-7700-a929-0e19fd490856.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-facd-7700-a929-0e19fd490856",
        "storage_key": "property/5713142352969728/019f14fb-facd-7700-a929-0e19fd490856.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.coj.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9416520470897936139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jacksonville-city-hall",
      "poi_latitude": "30.3297827",
      "poi_longitude": "-81.6591413",
      "poi_miles_from_property": "12.1 mi",
      "poi_walking_minutes": "4 hours 31 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 904-630-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019d02f2-1206-746d-b3c7-edb31e85748b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f2-1206-746d-b3c7-edb31e85748b",
        "storage_key": "property/5713142352969728/019d02f2-1206-746d-b3c7-edb31e85748b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeQU50xm35YgRC8cQOHozroI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_fc8a4cccadc6c867950a211b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a82a7b1b8243caefd76876d0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b1f829011828b9f342193aa9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5338251faecb0ccbe484cd04",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c51a8966673fa4a3fb134ce1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_31c61f47ab9588dcd8c01b70",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_debd2e780e3db49573cd9c3e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "rating": "5",
      "name": "Tanisha Hill",
      "text": "Stephany was fantastic to work with! She showed me an apartment today and made the entire experience enjoyable and stress-free. She was very knowledgeable, answered all my questions with confidence, and was extremely professional throughout. On top of that, she has the best smile and a very welcoming personality. I truly appreciated her help and would highly recommend working with her!",
      "date": "2026-02-06",
      "title": "false"
    },
    {
      "id": "ec_2bf7222c03a46698d3f04b21",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "rating": "5",
      "name": "Fauss Tatoute",
      "text": "I have lived here for a year and half and had no complaints at all. The community is peaceful and clean. The appliances are modern as well which is a huge plus. 5/5",
      "date": "2026-06-19",
      "title": "false"
    },
    {
      "id": "ec_2b71e60c9e208317861ad2ad",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "rating": "5",
      "name": "angela benoit",
      "text": "I recently contacted a company for AC maintenance, and I was impressed by their prompt response. Within 30 minutes of my call, a technician arrived to address the issue. I'm extremely grateful for the efficient service, especially considering I called on a Friday evening just before closing time. Their service undoubtedly deserves a five-star rating.",
      "date": "2026-03-06",
      "title": "false"
    },
    {
      "id": "ec_b12829493b01fe63cc71a310",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "rating": "5",
      "name": "Jamie Mitchell",
      "text": "Stephany in the leasing office is amazing she is super sweet, funny and very extremely kind. She has been extremely helpful throughout my entire move in process. Thank you for all your help Stephany! You’re greatly appreciated.",
      "date": "2026-05-06",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_d85933cfc05c10e3f58ef87f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f14c3-8f5e-718a-98bf-1c55b87c890f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-8f5e-718a-98bf-1c55b87c890f",
        "storage_key": "property/5713142352969728/019f14c3-8f5e-718a-98bf-1c55b87c890f.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Tapestry Westland Village - Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/XL4EIdISUqY"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-fbbd-741f-9025-23b6d8018e9f",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "tapestry-westland-village",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728"
    },
    {
      "lead_collector_id": "0198aa45-fc20-73b3-89d2-095e7dd0abfa",
      "lead_source": "FACEBOOK_ADS",
      "name": "tapestry-westland-village",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728"
    },
    {
      "lead_collector_id": "0198aa45-fc82-730a-a840-80d37b8652cc",
      "lead_source": "LANDING_PAGE",
      "name": "tapestry-westland-village",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "page_item_url": "luxury-apartments-with-pool-duclay-jacksonville-538",
      "search_query": "luxury apartments with pool in Duclay Jacksonville",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Duclay, Jacksonville",
      "h2_subtitle": "Experience luxury living with a resort-style pool in Duclay. Choose stylish one, two, or three-bedroom apartments at Tapestry Westland Village.",
      "page_copy": "Welcome to Tapestry Westland Village, where luxury meets comfort in Duclay, Jacksonville. Our luxury apartments with pool offer an unparalleled lifestyle, accentuated by our stunning resort-style pool area. Whether you prefer lounging by the water on a sunny afternoon or taking a refreshing dip in the evening, you'll find the perfect spot here. \n\nOur community boasts a variety of amenities beyond our beautiful pool, including stainless steel appliances in each apartment, a state-of-the-art fitness center, and a pet-friendly atmosphere featuring a dedicated dog park. Discover the ultimate combination of style and convenience in our one, two, and three-bedroom apartments, all nestled in the vibrant neighborhood of Duclay. Explore Tapestry Westland Village and elevate your living experience today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f6c10-e4c6-76f8-89e8-c3901b9dc8b1.webp",
      "featured_image_media": {
        "alt_text": "Luxurious bedroom with a king-size bed, designer bedding, and a dresser.",
        "public_id": "019f6c10-e4c6-76f8-89e8-c3901b9dc8b1",
        "storage_key": "property/5713142352969728/019f6c10-e4c6-76f8-89e8-c3901b9dc8b1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apts with Pool in Duclay, Jacksonville",
      "seo_description": "Discover luxury apartments with a pool in Duclay, Jacksonville at Tapestry Westland Village. Experience stylish living with top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-dog-park-duval-county-526",
      "search_query": "pet-friendly apartments with dog park Duval County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park in Duval",
      "h2_subtitle": "Find pet-friendly apartments complete with a dog park in Duval County. Tapestry Westland Village welcomes your furry friends!",
      "page_copy": "At Tapestry Westland Village in Duval County, we understand that pets are family. Our pet-friendly apartments with a dog park offer the perfect environment for both you and your four-legged companion. Watch them frolic and play in the designated dog park, ensuring an active and happy lifestyle. \n\nSituated in Jacksonville's charming neighborhood of Duclay, our community provides not only a haven for pets but also exceptional amenities for residents. Choose from one, two, or three-bedroom apartments featuring stainless steel appliances, a refreshing pool, and a convenient fitness center. Embrace a lifestyle where comfort and community blend seamlessly, making both you and your pets feel right at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f6c10-e4c6-76f8-89e8-c3901b9dc8b1.webp",
      "featured_image_media": {
        "alt_text": "Luxurious bedroom with a king-size bed, designer bedding, and a dresser.",
        "public_id": "019f6c10-e4c6-76f8-89e8-c3901b9dc8b1",
        "storage_key": "property/5713142352969728/019f6c10-e4c6-76f8-89e8-c3901b9dc8b1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apts with Dog Park Duval County",
      "seo_description": "Discover pet-friendly apartments with a dog park in Duval County at Tapestry Westland Village. Enjoy amenities for you and your pets in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "page_item_url": "apartments-in-unit-laundry-jacksonville-fl-228",
      "search_query": "apartments with in-unit laundry Jacksonville FL",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Jacksonville, FL",
      "h2_subtitle": "Enjoy the convenience of in-unit laundry at Tapestry Westland Village. Choose from one, two, or three-bedroom apartments in Jacksonville, FL.",
      "page_copy": "Discover the ease of living at Tapestry Westland Village, where each apartment in Jacksonville, FL comes equipped with in-unit laundry facilities. No more trips to the laundromat; enjoy the convenience of doing laundry right in the comfort of your home. Our thoughtfully designed one, two, and three-bedroom apartments are perfect for those seeking ease and style.\n\nLocated in the vibrant community of Duclay, our apartments not only offer in-unit laundry but also boast a myriad of luxurious amenities. Unwind by the resort-style pool, maintain your fitness routine in our state-of-the-art gym, or relax on your private patio. Experience the benefits of modern living while being part of a welcoming community at Tapestry Westland Village.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f6c10-e4c6-76f8-89e8-c3901b9dc8b1.webp",
      "featured_image_media": {
        "alt_text": "Luxurious bedroom with a king-size bed, designer bedding, and a dresser.",
        "public_id": "019f6c10-e4c6-76f8-89e8-c3901b9dc8b1",
        "storage_key": "property/5713142352969728/019f6c10-e4c6-76f8-89e8-c3901b9dc8b1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with In-Unit Laundry Jacksonville, FL",
      "seo_description": "Find apartments with in-unit laundry at Tapestry Westland Village, Jacksonville, FL. Enjoy convenient living with modern amenities at your doorstep.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-near-32244-193",
      "search_query": "air-conditioned apartments near 32244",
      "category": "Amenity",
      "h1_title": "Air-Conditioned Apartments Near 32244",
      "h2_subtitle": "Stay cool at Tapestry Westland Village. Explore air-conditioned apartments located conveniently near the 32244 zip code.",
      "page_copy": "Beat the Florida heat with air-conditioned apartments at Tapestry Westland Village, ideally located near the 32244 area. Each of our stylish one, two, and three-bedroom homes is designed with your comfort in mind, ensuring a serene retreat from the outside world, especially during those hot summer days.\n\nSituated in the inviting Duclay neighborhood of Jacksonville, our community offers a lifestyle filled with modern conveniences and luxury. You’ll love coming home to amenities such as a resort-style pool, Wi-Fi access, and a pet-friendly atmosphere complete with a dog park. Discover the comfortable living environment that Tapestry Westland Village offers and make it your new home base today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f6c10-e4c6-76f8-89e8-c3901b9dc8b1.webp",
      "featured_image_media": {
        "alt_text": "Luxurious bedroom with a king-size bed, designer bedding, and a dresser.",
        "public_id": "019f6c10-e4c6-76f8-89e8-c3901b9dc8b1",
        "storage_key": "property/5713142352969728/019f6c10-e4c6-76f8-89e8-c3901b9dc8b1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apts Near 32244",
      "seo_description": "Explore air-conditioned apartments near 32244 at Tapestry Westland Village. Enjoy comfort and convenience in our modern Jacksonville community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "page_item_url": "renters-insurance-program-apartments-westland-village-189",
      "search_query": "renters insurance program apartments in Westland Village",
      "category": "Amenity",
      "h1_title": "Renters Insurance Apartments in Westland Village",
      "h2_subtitle": "Discover apartments in Westland Village offering renters insurance programs. Tapestry Westland Village prioritizes your peace of mind.",
      "page_copy": "Located in the vibrant community of Duclay in Jacksonville, FL, Tapestry Westland Village offers an exceptional living experience with renters insurance programs available for residents. Our one, two, and three-bedroom apartments ensure that both comfort and safety are prioritized, giving you that extra peace of mind. \n\nWith our comprehensive renters insurance options, you can enjoy other luxurious amenities like stainless steel appliances, a refreshing pool, and a modern fitness center—knowing that you're covered. This welcoming community also features a pet-friendly atmosphere, complete with a dog park. Come explore the lifestyle that Tapestry Westland Village offers and experience safety and style under one roof.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f6c10-e4c6-76f8-89e8-c3901b9dc8b1.webp",
      "featured_image_media": {
        "alt_text": "Luxurious bedroom with a king-size bed, designer bedding, and a dresser.",
        "public_id": "019f6c10-e4c6-76f8-89e8-c3901b9dc8b1",
        "storage_key": "property/5713142352969728/019f6c10-e4c6-76f8-89e8-c3901b9dc8b1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Renters Insurance Program Apts Westland Village",
      "seo_description": "Explore renters insurance program apartments at Tapestry Westland Village. Enjoy secure, modern living in Jacksonville's vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-jacksonville-fl-132",
      "search_query": "one bedroom apartments jacksonville fl",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Jacksonville, FL",
      "h2_subtitle": "Explore luxury one bedroom apartments at Tapestry Westland Village in Jacksonville, FL. Modern amenities for your lifestyle needs.",
      "page_copy": "Searching for the perfect one bedroom apartment in Jacksonville, FL? Look no further than Tapestry Westland Village. Our thoughtfully designed one bedroom apartments offer a blend of sophistication and comfort, perfect for individuals or couples looking for a modern living space. \n\nLocated in Duclay, Jacksonville, our community provides not only stylish living quarters but also a wide range of amenities such as stainless steel appliances, a resort-style pool, and a well-equipped fitness center. Enjoy the convenience of high-speed Wi-Fi and a peaceful patio just steps outside your door. Discover your new home in an engaging community today at Tapestry Westland Village.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f6c10-e4c6-76f8-89e8-c3901b9dc8b1.webp",
      "featured_image_media": {
        "alt_text": "Luxurious bedroom with a king-size bed, designer bedding, and a dresser.",
        "public_id": "019f6c10-e4c6-76f8-89e8-c3901b9dc8b1",
        "storage_key": "property/5713142352969728/019f6c10-e4c6-76f8-89e8-c3901b9dc8b1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Jacksonville, FL",
      "seo_description": "Find modern one bedroom apartments at Tapestry Westland Village in Jacksonville, FL. Enjoy luxury amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-duval-county-127",
      "search_query": "two bedroom apartments duval county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Duval County",
      "h2_subtitle": "Discover elegant two bedroom apartments at Tapestry Westland Village in Duval County. Experience comfort and style in a prime location.",
      "page_copy": "Explore Tapestry Westland Village for spacious two bedroom apartments in Duval County. Our community offers a perfect mix of luxury and functionality, providing ample space with stylish interiors to cater to diverse lifestyle needs. \n\nNestled in the charming Duclay neighborhood of Jacksonville, FL, Tapestry Westland Village provides exceptional amenities such as a pool, a modern fitness center, and stainless steel appliances. Whether you’re relaxing on your patio or playing with your pet in our dog park, you'll find everything you need for a comfortable, connected living experience. Come and see why residents love calling Tapestry Westland Village home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f6c10-e4c6-76f8-89e8-c3901b9dc8b1.webp",
      "featured_image_media": {
        "alt_text": "Luxurious bedroom with a king-size bed, designer bedding, and a dresser.",
        "public_id": "019f6c10-e4c6-76f8-89e8-c3901b9dc8b1",
        "storage_key": "property/5713142352969728/019f6c10-e4c6-76f8-89e8-c3901b9dc8b1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Duval County",
      "seo_description": "Find spacious two bedroom apartments at Tapestry Westland Village in Duval County. Enjoy modern amenities and a prime Jacksonville location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5713142352969728",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-32244-81",
      "search_query": "three bedroom apartments near 32244",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 32244",
      "h2_subtitle": "Spacious three bedroom apartments near the 32244 area are available at Tapestry Westland Village in Jacksonville.",
      "page_copy": "If you're seeking spacious three bedroom apartments near the 32244 area, Tapestry Westland Village has what you need. Our beautifully designed apartments offer ample space for families or roommates with modern aesthetics and convenience in mind. \n\nLocated in the Duclay neighborhood of Jacksonville, FL, residents can enjoy a variety of amenities including a resort-style pool and state-of-the-art fitness center. Plus, with stainless steel appliances and high-speed Wi-Fi, you'll experience comfort and connectivity every day. Come and explore the vibrant community at Tapestry Westland Village where style meets functionality in the heart of Duval County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5713142352969728/019f6c10-e4c6-76f8-89e8-c3901b9dc8b1.webp",
      "featured_image_media": {
        "alt_text": "Luxurious bedroom with a king-size bed, designer bedding, and a dresser.",
        "public_id": "019f6c10-e4c6-76f8-89e8-c3901b9dc8b1",
        "storage_key": "property/5713142352969728/019f6c10-e4c6-76f8-89e8-c3901b9dc8b1.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 32244",
      "seo_description": "Discover three bedroom apartments at Tapestry Westland Village near 32244. Enjoy spacious living with modern amenities in Jacksonville.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2196"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376470889"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a4a\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a4a\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4892255"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W6JVBVP"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://tapestrywe.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443201073"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/8ywko522vlx"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/84a347ad-cf18-460e-9121-4138f1dc7d53"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "904-977-6559"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjlQSlYvNlNqZU1CeTBaOVIxVUEyNnc9PSIsInZhbHVlIjoieUJtcDZCWUNOd01ZaCtFakhXUWkyQT09IiwibWFjIjoiN2M0YjY2YjdlZTNkZjQ2ZjJkMjgwOWNlMjVmN2ZiOWRjOGVmMzYzZTBkNThiZDNkNmYxYTUwN2EwODIxNTEzOCJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2196",
  "custom_repli_id": "2376470889",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a4a\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a4a\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4892255",
  "custom_google_gtm_id": "GTM-W6JVBVP",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_betterbot_script": "<script src=\"https://tapestrywe.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443201073",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/8ywko522vlx",
  "custom_self_guided_tour_url": "https://selftournow.com/property/84a347ad-cf18-460e-9121-4138f1dc7d53",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "904-977-6559",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjlQSlYvNlNqZU1CeTBaOVIxVUEyNnc9PSIsInZhbHVlIjoieUJtcDZCWUNOd01ZaCtFakhXUWkyQT09IiwibWFjIjoiN2M0YjY2YjdlZTNkZjQ2ZjJkMjgwOWNlMjVmN2ZiOWRjOGVmMzYzZTBkNThiZDNkNmYxYTUwN2EwODIxNTEzOCJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-10-09T16:37:01.020Z';
